/**
 * Generated by orval v8.4.1 🍺
 * Do not edit manually.
 * Sales Call Grader API
 * AI-powered sales enablement platform
 * OpenAPI spec version: 2.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  ActiveOrgRequest,
  ActiveOrgResponse,
  AddTextRequest,
  AdminApproveRequest,
  AdminClaimsUpdate,
  AdminHealthResponse,
  AdminListOrganizationsParams,
  AdminOrgCreate,
  AdminOrgDetail,
  AdminOrgListResponse,
  AdminRejectRequest,
  AdminUserDetail,
  AdminUserListResponse,
  AuditLogListResponse,
  BodyUploadAndCreateTranscript,
  BodyUploadAvatar,
  BodyUploadFile,
  BodyUploadOrganizationLogo,
  BodyUploadTranscript,
  BulkTagRequest,
  BulkTagResponse,
  CloneRequest,
  ConversationCreate,
  ConversationDetail,
  ConversationResponse,
  ConversationUpdate,
  CountTokensRequest,
  CountTokensResponse,
  DashboardSummary,
  DeleteTranscriptResponse,
  ExportOrgAuditLogsParams,
  ExportSystemAuditLogsParams,
  FileCreate,
  FileResponse,
  FirefliesConnectRequest,
  FirefliesDisconnectResponse,
  FirefliesStatusResponse,
  FirefliesTranscriptListResponse,
  GenerateRequest,
  GenerateResponse,
  GetLlmUsageParams,
  GetMyScoresParams,
  GetMyTrendsParams,
  GetOrgSummaryParams,
  GetOrgUsersParams,
  GetScoresParams,
  GetSummaryParams,
  GetUsageParams,
  GetUserMetricsParams,
  HTTPValidationError,
  HealthResponse,
  ImportTranscriptResponse,
  InfoResponse,
  Invitation,
  ListConversationsParams,
  ListFirefliesTranscriptsParams,
  ListImportedTranscriptsParams,
  ListOrgAuditLogsParams,
  ListSystemAuditLogsParams,
  ListTranscriptsParams,
  ListUsersParams,
  LivenessResponse,
  LlmUsageBreakdown,
  Member,
  MemberInvite,
  MemberRoleUpdate,
  MessageCreate,
  ModelConfig,
  ModelInfo,
  MyScoresResponse,
  MyTrendsResponse,
  OrgSummaryResponse,
  OrgUsersResponse,
  Organization,
  OrganizationCreate,
  OrganizationUpdate,
  Prompt,
  PromptSummary,
  PromptType,
  PromptUpdate,
  PromptVersion,
  ReadinessResponse,
  ScoreAnalytics,
  SearchFirefliesTranscriptsParams,
  SearchRequest,
  SearchResponse,
  TagCount,
  Team,
  TeamCreate,
  TeamDetail,
  TeamMemberAdd,
  TeamUpdate,
  TranscriptListResponse,
  TranscriptUploadResponse,
  UploadAndCreateTranscriptParams,
  UploadUrlRequest,
  UploadUrlResponse,
  UsageOverTime,
  UserMetricsResponse,
  UserProfile,
  UserProfileUpdate,
  UserTranscriptCreate,
  UserTranscriptDetail,
  UserTranscriptListResponse,
  VectorStoreCreate,
  VectorStoreResponse,
  VectorStoreUpdate,
} from "./";

import { customInstance } from "../mutator";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Basic health check endpoint.

Returns a simple status to verify the service is running.
This endpoint requires no authentication.
 * @summary Health Check
 */
export type healthCheckResponse200 = {
  data: HealthResponse;
  status: 200;
};

export type healthCheckResponseSuccess = healthCheckResponse200 & {
  headers: Headers;
};
export type healthCheckResponse = healthCheckResponseSuccess;

export const getHealthCheckUrl = () => {
  return `/health`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<healthCheckResponse> => {
  return customInstance<healthCheckResponse>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/health`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = unknown;

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof healthCheck>>,
          TError,
          Awaited<ReturnType<typeof healthCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Health Check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Readiness probe for load balancer.

Checks if the service is ready to handle requests.
In future specs, this will verify database and other dependencies.
 * @summary Readiness Check
 */
export type readinessCheckResponse200 = {
  data: ReadinessResponse;
  status: 200;
};

export type readinessCheckResponseSuccess = readinessCheckResponse200 & {
  headers: Headers;
};
export type readinessCheckResponse = readinessCheckResponseSuccess;

export const getReadinessCheckUrl = () => {
  return `/health/ready`;
};

export const readinessCheck = async (
  options?: RequestInit,
): Promise<readinessCheckResponse> => {
  return customInstance<readinessCheckResponse>(getReadinessCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getReadinessCheckQueryKey = () => {
  return [`/health/ready`] as const;
};

export const getReadinessCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof readinessCheck>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getReadinessCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof readinessCheck>>> = ({
    signal,
  }) => readinessCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof readinessCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ReadinessCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof readinessCheck>>
>;
export type ReadinessCheckQueryError = unknown;

export function useReadinessCheck<
  TData = Awaited<ReturnType<typeof readinessCheck>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof readinessCheck>>,
          TError,
          Awaited<ReturnType<typeof readinessCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadinessCheck<
  TData = Awaited<ReturnType<typeof readinessCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof readinessCheck>>,
          TError,
          Awaited<ReturnType<typeof readinessCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useReadinessCheck<
  TData = Awaited<ReturnType<typeof readinessCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Readiness Check
 */

export function useReadinessCheck<
  TData = Awaited<ReturnType<typeof readinessCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof readinessCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getReadinessCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Liveness probe for container orchestration.

Returns alive status if the process is running.
This is used by Cloud Run to detect and restart unhealthy containers.
 * @summary Liveness Check
 */
export type livenessCheckResponse200 = {
  data: LivenessResponse;
  status: 200;
};

export type livenessCheckResponseSuccess = livenessCheckResponse200 & {
  headers: Headers;
};
export type livenessCheckResponse = livenessCheckResponseSuccess;

export const getLivenessCheckUrl = () => {
  return `/health/live`;
};

export const livenessCheck = async (
  options?: RequestInit,
): Promise<livenessCheckResponse> => {
  return customInstance<livenessCheckResponse>(getLivenessCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getLivenessCheckQueryKey = () => {
  return [`/health/live`] as const;
};

export const getLivenessCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof livenessCheck>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof livenessCheck>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLivenessCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof livenessCheck>>> = ({
    signal,
  }) => livenessCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof livenessCheck>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LivenessCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof livenessCheck>>
>;
export type LivenessCheckQueryError = unknown;

export function useLivenessCheck<
  TData = Awaited<ReturnType<typeof livenessCheck>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof livenessCheck>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof livenessCheck>>,
          TError,
          Awaited<ReturnType<typeof livenessCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLivenessCheck<
  TData = Awaited<ReturnType<typeof livenessCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof livenessCheck>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof livenessCheck>>,
          TError,
          Awaited<ReturnType<typeof livenessCheck>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useLivenessCheck<
  TData = Awaited<ReturnType<typeof livenessCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof livenessCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Liveness Check
 */

export function useLivenessCheck<
  TData = Awaited<ReturnType<typeof livenessCheck>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof livenessCheck>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getLivenessCheckQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get the authenticated user's profile.

Creates a profile if one doesn't exist yet (first login).
 * @summary Get Current User Profile
 */
export type getCurrentUserProfileResponse200 = {
  data: UserProfile;
  status: 200;
};

export type getCurrentUserProfileResponseSuccess =
  getCurrentUserProfileResponse200 & {
    headers: Headers;
  };
export type getCurrentUserProfileResponse =
  getCurrentUserProfileResponseSuccess;

export const getGetCurrentUserProfileUrl = () => {
  return `/api/v1/users/me`;
};

export const getCurrentUserProfile = async (
  options?: RequestInit,
): Promise<getCurrentUserProfileResponse> => {
  return customInstance<getCurrentUserProfileResponse>(
    getGetCurrentUserProfileUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCurrentUserProfileQueryKey = () => {
  return [`/api/v1/users/me`] as const;
};

export const getGetCurrentUserProfileQueryOptions = <
  TData = Awaited<ReturnType<typeof getCurrentUserProfile>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getCurrentUserProfile>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCurrentUserProfileQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCurrentUserProfile>>
  > = ({ signal }) => getCurrentUserProfile({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCurrentUserProfile>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCurrentUserProfileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCurrentUserProfile>>
>;
export type GetCurrentUserProfileQueryError = unknown;

export function useGetCurrentUserProfile<
  TData = Awaited<ReturnType<typeof getCurrentUserProfile>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentUserProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrentUserProfile<
  TData = Awaited<ReturnType<typeof getCurrentUserProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentUserProfile>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCurrentUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getCurrentUserProfile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCurrentUserProfile<
  TData = Awaited<ReturnType<typeof getCurrentUserProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentUserProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Current User Profile
 */

export function useGetCurrentUserProfile<
  TData = Awaited<ReturnType<typeof getCurrentUserProfile>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCurrentUserProfile>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCurrentUserProfileQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update the authenticated user's profile.
 * @summary Update Current User Profile
 */
export type updateCurrentUserProfileResponse200 = {
  data: UserProfile;
  status: 200;
};

export type updateCurrentUserProfileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateCurrentUserProfileResponseSuccess =
  updateCurrentUserProfileResponse200 & {
    headers: Headers;
  };
export type updateCurrentUserProfileResponseError =
  updateCurrentUserProfileResponse422 & {
    headers: Headers;
  };

export type updateCurrentUserProfileResponse =
  | updateCurrentUserProfileResponseSuccess
  | updateCurrentUserProfileResponseError;

export const getUpdateCurrentUserProfileUrl = () => {
  return `/api/v1/users/me`;
};

export const updateCurrentUserProfile = async (
  userProfileUpdate: UserProfileUpdate,
  options?: RequestInit,
): Promise<updateCurrentUserProfileResponse> => {
  return customInstance<updateCurrentUserProfileResponse>(
    getUpdateCurrentUserProfileUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(userProfileUpdate),
    },
  );
};

export const getUpdateCurrentUserProfileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCurrentUserProfile>>,
    TError,
    { data: UserProfileUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCurrentUserProfile>>,
  TError,
  { data: UserProfileUpdate },
  TContext
> => {
  const mutationKey = ["updateCurrentUserProfile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCurrentUserProfile>>,
    { data: UserProfileUpdate }
  > = (props) => {
    const { data } = props ?? {};

    return updateCurrentUserProfile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCurrentUserProfileMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCurrentUserProfile>>
>;
export type UpdateCurrentUserProfileMutationBody = UserProfileUpdate;
export type UpdateCurrentUserProfileMutationError = HTTPValidationError;

/**
 * @summary Update Current User Profile
 */
export const useUpdateCurrentUserProfile = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateCurrentUserProfile>>,
      TError,
      { data: UserProfileUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateCurrentUserProfile>>,
  TError,
  { data: UserProfileUpdate },
  TContext
> => {
  return useMutation(
    getUpdateCurrentUserProfileMutationOptions(options),
    queryClient,
  );
};

/**
 * Upload a user avatar image.

Accepts JPEG, PNG, or WebP. Max 2MB.
 * @summary Upload Avatar
 */
export type uploadAvatarResponse200 = {
  data: UserProfile;
  status: 200;
};

export type uploadAvatarResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadAvatarResponseSuccess = uploadAvatarResponse200 & {
  headers: Headers;
};
export type uploadAvatarResponseError = uploadAvatarResponse422 & {
  headers: Headers;
};

export type uploadAvatarResponse =
  | uploadAvatarResponseSuccess
  | uploadAvatarResponseError;

export const getUploadAvatarUrl = () => {
  return `/api/v1/users/me/avatar`;
};

export const uploadAvatar = async (
  bodyUploadAvatar: BodyUploadAvatar,
  options?: RequestInit,
): Promise<uploadAvatarResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadAvatar.file);

  return customInstance<uploadAvatarResponse>(getUploadAvatarUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadAvatarMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAvatar>>,
    TError,
    { data: BodyUploadAvatar },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadAvatar>>,
  TError,
  { data: BodyUploadAvatar },
  TContext
> => {
  const mutationKey = ["uploadAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAvatar>>,
    { data: BodyUploadAvatar }
  > = (props) => {
    const { data } = props ?? {};

    return uploadAvatar(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadAvatar>>
>;
export type UploadAvatarMutationBody = BodyUploadAvatar;
export type UploadAvatarMutationError = HTTPValidationError;

/**
 * @summary Upload Avatar
 */
export const useUploadAvatar = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadAvatar>>,
      TError,
      { data: BodyUploadAvatar },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadAvatar>>,
  TError,
  { data: BodyUploadAvatar },
  TContext
> => {
  return useMutation(getUploadAvatarMutationOptions(options), queryClient);
};

/**
 * Remove the user's avatar image.
 * @summary Remove Avatar
 */
export type removeAvatarResponse200 = {
  data: UserProfile;
  status: 200;
};

export type removeAvatarResponseSuccess = removeAvatarResponse200 & {
  headers: Headers;
};
export type removeAvatarResponse = removeAvatarResponseSuccess;

export const getRemoveAvatarUrl = () => {
  return `/api/v1/users/me/avatar`;
};

export const removeAvatar = async (
  options?: RequestInit,
): Promise<removeAvatarResponse> => {
  return customInstance<removeAvatarResponse>(getRemoveAvatarUrl(), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveAvatarMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeAvatar>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeAvatar>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["removeAvatar"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeAvatar>>,
    void
  > = () => {
    return removeAvatar(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveAvatarMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeAvatar>>
>;

export type RemoveAvatarMutationError = unknown;

/**
 * @summary Remove Avatar
 */
export const useRemoveAvatar = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeAvatar>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeAvatar>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getRemoveAvatarMutationOptions(options), queryClient);
};

/**
 * Switch the user's active organization.

Verifies membership then updates custom claims.
 * @summary Switch Active Org
 */
export type switchActiveOrgResponse200 = {
  data: ActiveOrgResponse;
  status: 200;
};

export type switchActiveOrgResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type switchActiveOrgResponseSuccess = switchActiveOrgResponse200 & {
  headers: Headers;
};
export type switchActiveOrgResponseError = switchActiveOrgResponse422 & {
  headers: Headers;
};

export type switchActiveOrgResponse =
  | switchActiveOrgResponseSuccess
  | switchActiveOrgResponseError;

export const getSwitchActiveOrgUrl = () => {
  return `/api/v1/users/me/active-org`;
};

export const switchActiveOrg = async (
  activeOrgRequest: ActiveOrgRequest,
  options?: RequestInit,
): Promise<switchActiveOrgResponse> => {
  return customInstance<switchActiveOrgResponse>(getSwitchActiveOrgUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(activeOrgRequest),
  });
};

export const getSwitchActiveOrgMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof switchActiveOrg>>,
    TError,
    { data: ActiveOrgRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof switchActiveOrg>>,
  TError,
  { data: ActiveOrgRequest },
  TContext
> => {
  const mutationKey = ["switchActiveOrg"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof switchActiveOrg>>,
    { data: ActiveOrgRequest }
  > = (props) => {
    const { data } = props ?? {};

    return switchActiveOrg(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SwitchActiveOrgMutationResult = NonNullable<
  Awaited<ReturnType<typeof switchActiveOrg>>
>;
export type SwitchActiveOrgMutationBody = ActiveOrgRequest;
export type SwitchActiveOrgMutationError = HTTPValidationError;

/**
 * @summary Switch Active Org
 */
export const useSwitchActiveOrg = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof switchActiveOrg>>,
      TError,
      { data: ActiveOrgRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof switchActiveOrg>>,
  TError,
  { data: ActiveOrgRequest },
  TContext
> => {
  return useMutation(getSwitchActiveOrgMutationOptions(options), queryClient);
};

/**
 * List all supported LLM models.
 * @summary List Models
 */
export type listModelsResponse200 = {
  data: ModelConfig[];
  status: 200;
};

export type listModelsResponseSuccess = listModelsResponse200 & {
  headers: Headers;
};
export type listModelsResponse = listModelsResponseSuccess;

export const getListModelsUrl = () => {
  return `/api/v1/models`;
};

export const listModels = async (
  options?: RequestInit,
): Promise<listModelsResponse> => {
  return customInstance<listModelsResponse>(getListModelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListModelsQueryKey = () => {
  return [`/api/v1/models`] as const;
};

export const getListModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof listModels>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listModels>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListModelsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listModels>>> = ({
    signal,
  }) => listModels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listModels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listModels>>
>;
export type ListModelsQueryError = unknown;

export function useListModels<
  TData = Awaited<ReturnType<typeof listModels>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModels>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModels>>,
          TError,
          Awaited<ReturnType<typeof listModels>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListModels<
  TData = Awaited<ReturnType<typeof listModels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModels>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listModels>>,
          TError,
          Awaited<ReturnType<typeof listModels>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListModels<
  TData = Awaited<ReturnType<typeof listModels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Models
 */

export function useListModels<
  TData = Awaited<ReturnType<typeof listModels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListModelsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List organizations the current user belongs to.
 * @summary List Organizations
 */
export type listOrganizationsResponse200 = {
  data: Organization[];
  status: 200;
};

export type listOrganizationsResponseSuccess = listOrganizationsResponse200 & {
  headers: Headers;
};
export type listOrganizationsResponse = listOrganizationsResponseSuccess;

export const getListOrganizationsUrl = () => {
  return `/api/v1/organizations`;
};

export const listOrganizations = async (
  options?: RequestInit,
): Promise<listOrganizationsResponse> => {
  return customInstance<listOrganizationsResponse>(getListOrganizationsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListOrganizationsQueryKey = () => {
  return [`/api/v1/organizations`] as const;
};

export const getListOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listOrganizations>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListOrganizationsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrganizations>>
  > = ({ signal }) => listOrganizations({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrganizations>>
>;
export type ListOrganizationsQueryError = unknown;

export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrganizations>>,
          TError,
          Awaited<ReturnType<typeof listOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Organizations
 */

export function useListOrganizations<
  TData = Awaited<ReturnType<typeof listOrganizations>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrganizationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a new organization. Super admin only.
 * @summary Create Organization
 */
export type createOrganizationResponse201 = {
  data: Organization;
  status: 201;
};

export type createOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createOrganizationResponseSuccess =
  createOrganizationResponse201 & {
    headers: Headers;
  };
export type createOrganizationResponseError = createOrganizationResponse422 & {
  headers: Headers;
};

export type createOrganizationResponse =
  | createOrganizationResponseSuccess
  | createOrganizationResponseError;

export const getCreateOrganizationUrl = () => {
  return `/api/v1/organizations`;
};

export const createOrganization = async (
  organizationCreate: OrganizationCreate,
  options?: RequestInit,
): Promise<createOrganizationResponse> => {
  return customInstance<createOrganizationResponse>(
    getCreateOrganizationUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(organizationCreate),
    },
  );
};

export const getCreateOrganizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createOrganization>>,
    TError,
    { data: OrganizationCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: OrganizationCreate },
  TContext
> => {
  const mutationKey = ["createOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createOrganization>>,
    { data: OrganizationCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createOrganization(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createOrganization>>
>;
export type CreateOrganizationMutationBody = OrganizationCreate;
export type CreateOrganizationMutationError = HTTPValidationError;

/**
 * @summary Create Organization
 */
export const useCreateOrganization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createOrganization>>,
      TError,
      { data: OrganizationCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createOrganization>>,
  TError,
  { data: OrganizationCreate },
  TContext
> => {
  return useMutation(
    getCreateOrganizationMutationOptions(options),
    queryClient,
  );
};

/**
 * Get organization details. Requires membership.
 * @summary Get Organization
 */
export type getOrganizationResponse200 = {
  data: Organization;
  status: 200;
};

export type getOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrganizationResponseSuccess = getOrganizationResponse200 & {
  headers: Headers;
};
export type getOrganizationResponseError = getOrganizationResponse422 & {
  headers: Headers;
};

export type getOrganizationResponse =
  | getOrganizationResponseSuccess
  | getOrganizationResponseError;

export const getGetOrganizationUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}`;
};

export const getOrganization = async (
  orgId: string,
  options?: RequestInit,
): Promise<getOrganizationResponse> => {
  return customInstance<getOrganizationResponse>(getGetOrganizationUrl(orgId), {
    ...options,
    method: "GET",
  });
};

export const getGetOrganizationQueryKey = (orgId: string) => {
  return [`/api/v1/organizations/${orgId}`] as const;
};

export const getGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrganizationQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrganization>>> = ({
    signal,
  }) => getOrganization(orgId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!orgId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrganization>>
>;
export type GetOrganizationQueryError = HTTPValidationError;

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrganization>>,
          TError,
          Awaited<ReturnType<typeof getOrganization>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Organization
 */

export function useGetOrganization<
  TData = Awaited<ReturnType<typeof getOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrganizationQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update organization. Requires org_owner role.
 * @summary Update Organization
 */
export type updateOrganizationResponse200 = {
  data: Organization;
  status: 200;
};

export type updateOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateOrganizationResponseSuccess =
  updateOrganizationResponse200 & {
    headers: Headers;
  };
export type updateOrganizationResponseError = updateOrganizationResponse422 & {
  headers: Headers;
};

export type updateOrganizationResponse =
  | updateOrganizationResponseSuccess
  | updateOrganizationResponseError;

export const getUpdateOrganizationUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}`;
};

export const updateOrganization = async (
  orgId: string,
  organizationUpdate: OrganizationUpdate,
  options?: RequestInit,
): Promise<updateOrganizationResponse> => {
  return customInstance<updateOrganizationResponse>(
    getUpdateOrganizationUrl(orgId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(organizationUpdate),
    },
  );
};

export const getUpdateOrganizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrganization>>,
    TError,
    { orgId: string; data: OrganizationUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { orgId: string; data: OrganizationUpdate },
  TContext
> => {
  const mutationKey = ["updateOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrganization>>,
    { orgId: string; data: OrganizationUpdate }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return updateOrganization(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrganization>>
>;
export type UpdateOrganizationMutationBody = OrganizationUpdate;
export type UpdateOrganizationMutationError = HTTPValidationError;

/**
 * @summary Update Organization
 */
export const useUpdateOrganization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrganization>>,
      TError,
      { orgId: string; data: OrganizationUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrganization>>,
  TError,
  { orgId: string; data: OrganizationUpdate },
  TContext
> => {
  return useMutation(
    getUpdateOrganizationMutationOptions(options),
    queryClient,
  );
};

/**
 * Delete organization. Requires org_owner role.
 * @summary Delete Organization
 */
export type deleteOrganizationResponse204 = {
  data: void;
  status: 204;
};

export type deleteOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteOrganizationResponseSuccess =
  deleteOrganizationResponse204 & {
    headers: Headers;
  };
export type deleteOrganizationResponseError = deleteOrganizationResponse422 & {
  headers: Headers;
};

export type deleteOrganizationResponse =
  | deleteOrganizationResponseSuccess
  | deleteOrganizationResponseError;

export const getDeleteOrganizationUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}`;
};

export const deleteOrganization = async (
  orgId: string,
  options?: RequestInit,
): Promise<deleteOrganizationResponse> => {
  return customInstance<deleteOrganizationResponse>(
    getDeleteOrganizationUrl(orgId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteOrganizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrganization>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrganization>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ["deleteOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrganization>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return deleteOrganization(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrganization>>
>;

export type DeleteOrganizationMutationError = HTTPValidationError;

/**
 * @summary Delete Organization
 */
export const useDeleteOrganization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrganization>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrganization>>,
  TError,
  { orgId: string },
  TContext
> => {
  return useMutation(
    getDeleteOrganizationMutationOptions(options),
    queryClient,
  );
};

/**
 * Upload an organization logo (white-label branding).

Requires org_owner role, or super-admin (to set up any org — spec 037).
Accepts JPEG, PNG, or WebP. Max 2MB.
 * @summary Upload Organization Logo
 */
export type uploadOrganizationLogoResponse200 = {
  data: Organization;
  status: 200;
};

export type uploadOrganizationLogoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadOrganizationLogoResponseSuccess =
  uploadOrganizationLogoResponse200 & {
    headers: Headers;
  };
export type uploadOrganizationLogoResponseError =
  uploadOrganizationLogoResponse422 & {
    headers: Headers;
  };

export type uploadOrganizationLogoResponse =
  | uploadOrganizationLogoResponseSuccess
  | uploadOrganizationLogoResponseError;

export const getUploadOrganizationLogoUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}/logo`;
};

export const uploadOrganizationLogo = async (
  orgId: string,
  bodyUploadOrganizationLogo: BodyUploadOrganizationLogo,
  options?: RequestInit,
): Promise<uploadOrganizationLogoResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadOrganizationLogo.file);

  return customInstance<uploadOrganizationLogoResponse>(
    getUploadOrganizationLogoUrl(orgId),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getUploadOrganizationLogoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadOrganizationLogo>>,
    TError,
    { orgId: string; data: BodyUploadOrganizationLogo },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadOrganizationLogo>>,
  TError,
  { orgId: string; data: BodyUploadOrganizationLogo },
  TContext
> => {
  const mutationKey = ["uploadOrganizationLogo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadOrganizationLogo>>,
    { orgId: string; data: BodyUploadOrganizationLogo }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return uploadOrganizationLogo(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadOrganizationLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadOrganizationLogo>>
>;
export type UploadOrganizationLogoMutationBody = BodyUploadOrganizationLogo;
export type UploadOrganizationLogoMutationError = HTTPValidationError;

/**
 * @summary Upload Organization Logo
 */
export const useUploadOrganizationLogo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadOrganizationLogo>>,
      TError,
      { orgId: string; data: BodyUploadOrganizationLogo },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadOrganizationLogo>>,
  TError,
  { orgId: string; data: BodyUploadOrganizationLogo },
  TContext
> => {
  return useMutation(
    getUploadOrganizationLogoMutationOptions(options),
    queryClient,
  );
};

/**
 * Remove the organization logo. Requires org_owner role, or super-admin (spec 037).
 * @summary Remove Organization Logo
 */
export type removeOrganizationLogoResponse200 = {
  data: Organization;
  status: 200;
};

export type removeOrganizationLogoResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeOrganizationLogoResponseSuccess =
  removeOrganizationLogoResponse200 & {
    headers: Headers;
  };
export type removeOrganizationLogoResponseError =
  removeOrganizationLogoResponse422 & {
    headers: Headers;
  };

export type removeOrganizationLogoResponse =
  | removeOrganizationLogoResponseSuccess
  | removeOrganizationLogoResponseError;

export const getRemoveOrganizationLogoUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}/logo`;
};

export const removeOrganizationLogo = async (
  orgId: string,
  options?: RequestInit,
): Promise<removeOrganizationLogoResponse> => {
  return customInstance<removeOrganizationLogoResponse>(
    getRemoveOrganizationLogoUrl(orgId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveOrganizationLogoMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeOrganizationLogo>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeOrganizationLogo>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ["removeOrganizationLogo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeOrganizationLogo>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return removeOrganizationLogo(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveOrganizationLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeOrganizationLogo>>
>;

export type RemoveOrganizationLogoMutationError = HTTPValidationError;

/**
 * @summary Remove Organization Logo
 */
export const useRemoveOrganizationLogo = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeOrganizationLogo>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeOrganizationLogo>>,
  TError,
  { orgId: string },
  TContext
> => {
  return useMutation(
    getRemoveOrganizationLogoMutationOptions(options),
    queryClient,
  );
};

/**
 * List all members of an organization.
 * @summary List Members
 */
export type listMembersResponse200 = {
  data: Member[];
  status: 200;
};

export type listMembersResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listMembersResponseSuccess = listMembersResponse200 & {
  headers: Headers;
};
export type listMembersResponseError = listMembersResponse422 & {
  headers: Headers;
};

export type listMembersResponse =
  | listMembersResponseSuccess
  | listMembersResponseError;

export const getListMembersUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}/members`;
};

export const listMembers = async (
  orgId: string,
  options?: RequestInit,
): Promise<listMembersResponse> => {
  return customInstance<listMembersResponse>(getListMembersUrl(orgId), {
    ...options,
    method: "GET",
  });
};

export const getListMembersQueryKey = (orgId: string) => {
  return [`/api/v1/organizations/${orgId}/members`] as const;
};

export const getListMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListMembersQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listMembers>>> = ({
    signal,
  }) => listMembers(orgId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!orgId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMembers>>
>;
export type ListMembersQueryError = HTTPValidationError;

export function useListMembers<
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMembers<
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMembers<
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Members
 */

export function useListMembers<
  TData = Awaited<ReturnType<typeof listMembers>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listMembers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListMembersQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Invite a new member. Requires org_owner+ role.
 * @summary Invite Member
 */
export type inviteMemberResponse201 = {
  data: Member | Invitation;
  status: 201;
};

export type inviteMemberResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type inviteMemberResponseSuccess = inviteMemberResponse201 & {
  headers: Headers;
};
export type inviteMemberResponseError = inviteMemberResponse422 & {
  headers: Headers;
};

export type inviteMemberResponse =
  | inviteMemberResponseSuccess
  | inviteMemberResponseError;

export const getInviteMemberUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}/members`;
};

export const inviteMember = async (
  orgId: string,
  memberInvite: MemberInvite,
  options?: RequestInit,
): Promise<inviteMemberResponse> => {
  return customInstance<inviteMemberResponse>(getInviteMemberUrl(orgId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(memberInvite),
  });
};

export const getInviteMemberMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof inviteMember>>,
    TError,
    { orgId: string; data: MemberInvite },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof inviteMember>>,
  TError,
  { orgId: string; data: MemberInvite },
  TContext
> => {
  const mutationKey = ["inviteMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof inviteMember>>,
    { orgId: string; data: MemberInvite }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return inviteMember(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type InviteMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof inviteMember>>
>;
export type InviteMemberMutationBody = MemberInvite;
export type InviteMemberMutationError = HTTPValidationError;

/**
 * @summary Invite Member
 */
export const useInviteMember = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof inviteMember>>,
      TError,
      { orgId: string; data: MemberInvite },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof inviteMember>>,
  TError,
  { orgId: string; data: MemberInvite },
  TContext
> => {
  return useMutation(getInviteMemberMutationOptions(options), queryClient);
};

/**
 * Get a specific member's details.
 * @summary Get Member
 */
export type getMemberResponse200 = {
  data: Member;
  status: 200;
};

export type getMemberResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getMemberResponseSuccess = getMemberResponse200 & {
  headers: Headers;
};
export type getMemberResponseError = getMemberResponse422 & {
  headers: Headers;
};

export type getMemberResponse =
  | getMemberResponseSuccess
  | getMemberResponseError;

export const getGetMemberUrl = (orgId: string, uid: string) => {
  return `/api/v1/organizations/${orgId}/members/${uid}`;
};

export const getMember = async (
  orgId: string,
  uid: string,
  options?: RequestInit,
): Promise<getMemberResponse> => {
  return customInstance<getMemberResponse>(getGetMemberUrl(orgId, uid), {
    ...options,
    method: "GET",
  });
};

export const getGetMemberQueryKey = (orgId: string, uid: string) => {
  return [`/api/v1/organizations/${orgId}/members/${uid}`] as const;
};

export const getGetMemberQueryOptions = <
  TData = Awaited<ReturnType<typeof getMember>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  uid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMemberQueryKey(orgId, uid);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMember>>> = ({
    signal,
  }) => getMember(orgId, uid, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && uid),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetMemberQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMember>>
>;
export type GetMemberQueryError = HTTPValidationError;

export function useGetMember<
  TData = Awaited<ReturnType<typeof getMember>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  uid: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMember>>,
          TError,
          Awaited<ReturnType<typeof getMember>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMember<
  TData = Awaited<ReturnType<typeof getMember>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  uid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMember>>,
          TError,
          Awaited<ReturnType<typeof getMember>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMember<
  TData = Awaited<ReturnType<typeof getMember>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  uid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Member
 */

export function useGetMember<
  TData = Awaited<ReturnType<typeof getMember>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  uid: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMember>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMemberQueryOptions(orgId, uid, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update a member's role. Requires org_owner+ role.
 * @summary Update Member Role
 */
export type updateMemberRoleResponse200 = {
  data: Member;
  status: 200;
};

export type updateMemberRoleResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateMemberRoleResponseSuccess = updateMemberRoleResponse200 & {
  headers: Headers;
};
export type updateMemberRoleResponseError = updateMemberRoleResponse422 & {
  headers: Headers;
};

export type updateMemberRoleResponse =
  | updateMemberRoleResponseSuccess
  | updateMemberRoleResponseError;

export const getUpdateMemberRoleUrl = (orgId: string, uid: string) => {
  return `/api/v1/organizations/${orgId}/members/${uid}`;
};

export const updateMemberRole = async (
  orgId: string,
  uid: string,
  memberRoleUpdate: MemberRoleUpdate,
  options?: RequestInit,
): Promise<updateMemberRoleResponse> => {
  return customInstance<updateMemberRoleResponse>(
    getUpdateMemberRoleUrl(orgId, uid),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(memberRoleUpdate),
    },
  );
};

export const getUpdateMemberRoleMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateMemberRole>>,
    TError,
    { orgId: string; uid: string; data: MemberRoleUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateMemberRole>>,
  TError,
  { orgId: string; uid: string; data: MemberRoleUpdate },
  TContext
> => {
  const mutationKey = ["updateMemberRole"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateMemberRole>>,
    { orgId: string; uid: string; data: MemberRoleUpdate }
  > = (props) => {
    const { orgId, uid, data } = props ?? {};

    return updateMemberRole(orgId, uid, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateMemberRoleMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateMemberRole>>
>;
export type UpdateMemberRoleMutationBody = MemberRoleUpdate;
export type UpdateMemberRoleMutationError = HTTPValidationError;

/**
 * @summary Update Member Role
 */
export const useUpdateMemberRole = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateMemberRole>>,
      TError,
      { orgId: string; uid: string; data: MemberRoleUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateMemberRole>>,
  TError,
  { orgId: string; uid: string; data: MemberRoleUpdate },
  TContext
> => {
  return useMutation(getUpdateMemberRoleMutationOptions(options), queryClient);
};

/**
 * Remove a member. Requires org_owner+ role.
 * @summary Remove Member
 */
export type removeMemberResponse204 = {
  data: void;
  status: 204;
};

export type removeMemberResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeMemberResponseSuccess = removeMemberResponse204 & {
  headers: Headers;
};
export type removeMemberResponseError = removeMemberResponse422 & {
  headers: Headers;
};

export type removeMemberResponse =
  | removeMemberResponseSuccess
  | removeMemberResponseError;

export const getRemoveMemberUrl = (orgId: string, uid: string) => {
  return `/api/v1/organizations/${orgId}/members/${uid}`;
};

export const removeMember = async (
  orgId: string,
  uid: string,
  options?: RequestInit,
): Promise<removeMemberResponse> => {
  return customInstance<removeMemberResponse>(getRemoveMemberUrl(orgId, uid), {
    ...options,
    method: "DELETE",
  });
};

export const getRemoveMemberMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMember>>,
    TError,
    { orgId: string; uid: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeMember>>,
  TError,
  { orgId: string; uid: string },
  TContext
> => {
  const mutationKey = ["removeMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeMember>>,
    { orgId: string; uid: string }
  > = (props) => {
    const { orgId, uid } = props ?? {};

    return removeMember(orgId, uid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeMember>>
>;

export type RemoveMemberMutationError = HTTPValidationError;

/**
 * @summary Remove Member
 */
export const useRemoveMember = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeMember>>,
      TError,
      { orgId: string; uid: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeMember>>,
  TError,
  { orgId: string; uid: string },
  TContext
> => {
  return useMutation(getRemoveMemberMutationOptions(options), queryClient);
};

/**
 * List all prompt types with their resolution status for the user's org.
 * @summary List Prompts
 */
export type listPromptsResponse200 = {
  data: PromptSummary[];
  status: 200;
};

export type listPromptsResponseSuccess = listPromptsResponse200 & {
  headers: Headers;
};
export type listPromptsResponse = listPromptsResponseSuccess;

export const getListPromptsUrl = () => {
  return `/api/v1/prompts`;
};

export const listPrompts = async (
  options?: RequestInit,
): Promise<listPromptsResponse> => {
  return customInstance<listPromptsResponse>(getListPromptsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPromptsQueryKey = () => {
  return [`/api/v1/prompts`] as const;
};

export const getListPromptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPromptsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listPrompts>>> = ({
    signal,
  }) => listPrompts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPrompts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListPromptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPrompts>>
>;
export type ListPromptsQueryError = unknown;

export function useListPrompts<
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrompts>>,
          TError,
          Awaited<ReturnType<typeof listPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPrompts<
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listPrompts>>,
          TError,
          Awaited<ReturnType<typeof listPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListPrompts<
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Prompts
 */

export function useListPrompts<
  TData = Awaited<ReturnType<typeof listPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listPrompts>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListPromptsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List all default prompts.
 * @summary List Default Prompts
 */
export type listDefaultPromptsResponse200 = {
  data: Prompt[];
  status: 200;
};

export type listDefaultPromptsResponseSuccess =
  listDefaultPromptsResponse200 & {
    headers: Headers;
  };
export type listDefaultPromptsResponse = listDefaultPromptsResponseSuccess;

export const getListDefaultPromptsUrl = () => {
  return `/api/v1/admin/prompts`;
};

export const listDefaultPrompts = async (
  options?: RequestInit,
): Promise<listDefaultPromptsResponse> => {
  return customInstance<listDefaultPromptsResponse>(
    getListDefaultPromptsUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListDefaultPromptsQueryKey = () => {
  return [`/api/v1/admin/prompts`] as const;
};

export const getListDefaultPromptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listDefaultPrompts>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof listDefaultPrompts>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListDefaultPromptsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDefaultPrompts>>
  > = ({ signal }) => listDefaultPrompts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDefaultPrompts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListDefaultPromptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDefaultPrompts>>
>;
export type ListDefaultPromptsQueryError = unknown;

export function useListDefaultPrompts<
  TData = Awaited<ReturnType<typeof listDefaultPrompts>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultPrompts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefaultPrompts>>,
          TError,
          Awaited<ReturnType<typeof listDefaultPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDefaultPrompts<
  TData = Awaited<ReturnType<typeof listDefaultPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultPrompts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDefaultPrompts>>,
          TError,
          Awaited<ReturnType<typeof listDefaultPrompts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListDefaultPrompts<
  TData = Awaited<ReturnType<typeof listDefaultPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Default Prompts
 */

export function useListDefaultPrompts<
  TData = Awaited<ReturnType<typeof listDefaultPrompts>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listDefaultPrompts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListDefaultPromptsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get a default prompt by type.
 * @summary Get Default Prompt
 */
export type getDefaultPromptResponse200 = {
  data: Prompt;
  status: 200;
};

export type getDefaultPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getDefaultPromptResponseSuccess = getDefaultPromptResponse200 & {
  headers: Headers;
};
export type getDefaultPromptResponseError = getDefaultPromptResponse422 & {
  headers: Headers;
};

export type getDefaultPromptResponse =
  | getDefaultPromptResponseSuccess
  | getDefaultPromptResponseError;

export const getGetDefaultPromptUrl = (promptType: PromptType) => {
  return `/api/v1/admin/prompts/${promptType}`;
};

export const getDefaultPrompt = async (
  promptType: PromptType,
  options?: RequestInit,
): Promise<getDefaultPromptResponse> => {
  return customInstance<getDefaultPromptResponse>(
    getGetDefaultPromptUrl(promptType),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDefaultPromptQueryKey = (promptType: PromptType) => {
  return [`/api/v1/admin/prompts/${promptType}`] as const;
};

export const getGetDefaultPromptQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultPrompt>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPrompt>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDefaultPromptQueryKey(promptType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDefaultPrompt>>
  > = ({ signal }) =>
    getDefaultPrompt(promptType, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!promptType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDefaultPrompt>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDefaultPromptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDefaultPrompt>>
>;
export type GetDefaultPromptQueryError = HTTPValidationError;

export function useGetDefaultPrompt<
  TData = Awaited<ReturnType<typeof getDefaultPrompt>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPrompt>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultPrompt>>,
          TError,
          Awaited<ReturnType<typeof getDefaultPrompt>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDefaultPrompt<
  TData = Awaited<ReturnType<typeof getDefaultPrompt>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPrompt>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultPrompt>>,
          TError,
          Awaited<ReturnType<typeof getDefaultPrompt>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDefaultPrompt<
  TData = Awaited<ReturnType<typeof getDefaultPrompt>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPrompt>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Default Prompt
 */

export function useGetDefaultPrompt<
  TData = Awaited<ReturnType<typeof getDefaultPrompt>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPrompt>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDefaultPromptQueryOptions(promptType, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update a default prompt.
 * @summary Update Default Prompt
 */
export type updateDefaultPromptResponse200 = {
  data: Prompt;
  status: 200;
};

export type updateDefaultPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateDefaultPromptResponseSuccess =
  updateDefaultPromptResponse200 & {
    headers: Headers;
  };
export type updateDefaultPromptResponseError =
  updateDefaultPromptResponse422 & {
    headers: Headers;
  };

export type updateDefaultPromptResponse =
  | updateDefaultPromptResponseSuccess
  | updateDefaultPromptResponseError;

export const getUpdateDefaultPromptUrl = (promptType: PromptType) => {
  return `/api/v1/admin/prompts/${promptType}`;
};

export const updateDefaultPrompt = async (
  promptType: PromptType,
  promptUpdate: PromptUpdate,
  options?: RequestInit,
): Promise<updateDefaultPromptResponse> => {
  return customInstance<updateDefaultPromptResponse>(
    getUpdateDefaultPromptUrl(promptType),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(promptUpdate),
    },
  );
};

export const getUpdateDefaultPromptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDefaultPrompt>>,
    TError,
    { promptType: PromptType; data: PromptUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateDefaultPrompt>>,
  TError,
  { promptType: PromptType; data: PromptUpdate },
  TContext
> => {
  const mutationKey = ["updateDefaultPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDefaultPrompt>>,
    { promptType: PromptType; data: PromptUpdate }
  > = (props) => {
    const { promptType, data } = props ?? {};

    return updateDefaultPrompt(promptType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDefaultPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDefaultPrompt>>
>;
export type UpdateDefaultPromptMutationBody = PromptUpdate;
export type UpdateDefaultPromptMutationError = HTTPValidationError;

/**
 * @summary Update Default Prompt
 */
export const useUpdateDefaultPrompt = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateDefaultPrompt>>,
      TError,
      { promptType: PromptType; data: PromptUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateDefaultPrompt>>,
  TError,
  { promptType: PromptType; data: PromptUpdate },
  TContext
> => {
  return useMutation(
    getUpdateDefaultPromptMutationOptions(options),
    queryClient,
  );
};

/**
 * Get version history for a default prompt.
 * @summary Get Default Prompt History
 */
export type getDefaultPromptHistoryResponse200 = {
  data: PromptVersion[];
  status: 200;
};

export type getDefaultPromptHistoryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getDefaultPromptHistoryResponseSuccess =
  getDefaultPromptHistoryResponse200 & {
    headers: Headers;
  };
export type getDefaultPromptHistoryResponseError =
  getDefaultPromptHistoryResponse422 & {
    headers: Headers;
  };

export type getDefaultPromptHistoryResponse =
  | getDefaultPromptHistoryResponseSuccess
  | getDefaultPromptHistoryResponseError;

export const getGetDefaultPromptHistoryUrl = (promptType: PromptType) => {
  return `/api/v1/admin/prompts/${promptType}/history`;
};

export const getDefaultPromptHistory = async (
  promptType: PromptType,
  options?: RequestInit,
): Promise<getDefaultPromptHistoryResponse> => {
  return customInstance<getDefaultPromptHistoryResponse>(
    getGetDefaultPromptHistoryUrl(promptType),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetDefaultPromptHistoryQueryKey = (promptType: PromptType) => {
  return [`/api/v1/admin/prompts/${promptType}/history`] as const;
};

export const getGetDefaultPromptHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getDefaultPromptHistory>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPromptHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetDefaultPromptHistoryQueryKey(promptType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDefaultPromptHistory>>
  > = ({ signal }) =>
    getDefaultPromptHistory(promptType, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!promptType,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDefaultPromptHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetDefaultPromptHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDefaultPromptHistory>>
>;
export type GetDefaultPromptHistoryQueryError = HTTPValidationError;

export function useGetDefaultPromptHistory<
  TData = Awaited<ReturnType<typeof getDefaultPromptHistory>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPromptHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultPromptHistory>>,
          TError,
          Awaited<ReturnType<typeof getDefaultPromptHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDefaultPromptHistory<
  TData = Awaited<ReturnType<typeof getDefaultPromptHistory>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPromptHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultPromptHistory>>,
          TError,
          Awaited<ReturnType<typeof getDefaultPromptHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetDefaultPromptHistory<
  TData = Awaited<ReturnType<typeof getDefaultPromptHistory>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPromptHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Default Prompt History
 */

export function useGetDefaultPromptHistory<
  TData = Awaited<ReturnType<typeof getDefaultPromptHistory>>,
  TError = HTTPValidationError,
>(
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getDefaultPromptHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetDefaultPromptHistoryQueryOptions(
    promptType,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Rollback a default prompt to a specific version.
 * @summary Rollback Default Prompt
 */
export type rollbackDefaultPromptResponse200 = {
  data: Prompt;
  status: 200;
};

export type rollbackDefaultPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type rollbackDefaultPromptResponseSuccess =
  rollbackDefaultPromptResponse200 & {
    headers: Headers;
  };
export type rollbackDefaultPromptResponseError =
  rollbackDefaultPromptResponse422 & {
    headers: Headers;
  };

export type rollbackDefaultPromptResponse =
  | rollbackDefaultPromptResponseSuccess
  | rollbackDefaultPromptResponseError;

export const getRollbackDefaultPromptUrl = (
  promptType: PromptType,
  version: number,
) => {
  return `/api/v1/admin/prompts/${promptType}/rollback/${version}`;
};

export const rollbackDefaultPrompt = async (
  promptType: PromptType,
  version: number,
  options?: RequestInit,
): Promise<rollbackDefaultPromptResponse> => {
  return customInstance<rollbackDefaultPromptResponse>(
    getRollbackDefaultPromptUrl(promptType, version),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRollbackDefaultPromptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rollbackDefaultPrompt>>,
    TError,
    { promptType: PromptType; version: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rollbackDefaultPrompt>>,
  TError,
  { promptType: PromptType; version: number },
  TContext
> => {
  const mutationKey = ["rollbackDefaultPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rollbackDefaultPrompt>>,
    { promptType: PromptType; version: number }
  > = (props) => {
    const { promptType, version } = props ?? {};

    return rollbackDefaultPrompt(promptType, version, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RollbackDefaultPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof rollbackDefaultPrompt>>
>;

export type RollbackDefaultPromptMutationError = HTTPValidationError;

/**
 * @summary Rollback Default Prompt
 */
export const useRollbackDefaultPrompt = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rollbackDefaultPrompt>>,
      TError,
      { promptType: PromptType; version: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rollbackDefaultPrompt>>,
  TError,
  { promptType: PromptType; version: number },
  TContext
> => {
  return useMutation(
    getRollbackDefaultPromptMutationOptions(options),
    queryClient,
  );
};

/**
 * Clone a prompt to a target organization.
 * @summary Clone Prompt
 */
export type clonePromptResponse200 = {
  data: Prompt;
  status: 200;
};

export type clonePromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type clonePromptResponseSuccess = clonePromptResponse200 & {
  headers: Headers;
};
export type clonePromptResponseError = clonePromptResponse422 & {
  headers: Headers;
};

export type clonePromptResponse =
  | clonePromptResponseSuccess
  | clonePromptResponseError;

export const getClonePromptUrl = (promptType: PromptType) => {
  return `/api/v1/admin/prompts/${promptType}/clone`;
};

export const clonePrompt = async (
  promptType: PromptType,
  cloneRequest: CloneRequest,
  options?: RequestInit,
): Promise<clonePromptResponse> => {
  return customInstance<clonePromptResponse>(getClonePromptUrl(promptType), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(cloneRequest),
  });
};

export const getClonePromptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof clonePrompt>>,
    TError,
    { promptType: PromptType; data: CloneRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof clonePrompt>>,
  TError,
  { promptType: PromptType; data: CloneRequest },
  TContext
> => {
  const mutationKey = ["clonePrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof clonePrompt>>,
    { promptType: PromptType; data: CloneRequest }
  > = (props) => {
    const { promptType, data } = props ?? {};

    return clonePrompt(promptType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ClonePromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof clonePrompt>>
>;
export type ClonePromptMutationBody = CloneRequest;
export type ClonePromptMutationError = HTTPValidationError;

/**
 * @summary Clone Prompt
 */
export const useClonePrompt = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof clonePrompt>>,
      TError,
      { promptType: PromptType; data: CloneRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof clonePrompt>>,
  TError,
  { promptType: PromptType; data: CloneRequest },
  TContext
> => {
  return useMutation(getClonePromptMutationOptions(options), queryClient);
};

/**
 * Get an org's prompt override.
 * @summary Get Org Prompt
 */
export type getOrgPromptResponse200 = {
  data: Prompt | null;
  status: 200;
};

export type getOrgPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrgPromptResponseSuccess = getOrgPromptResponse200 & {
  headers: Headers;
};
export type getOrgPromptResponseError = getOrgPromptResponse422 & {
  headers: Headers;
};

export type getOrgPromptResponse =
  | getOrgPromptResponseSuccess
  | getOrgPromptResponseError;

export const getGetOrgPromptUrl = (orgId: string, promptType: PromptType) => {
  return `/api/v1/admin/prompts/orgs/${orgId}/${promptType}`;
};

export const getOrgPrompt = async (
  orgId: string,
  promptType: PromptType,
  options?: RequestInit,
): Promise<getOrgPromptResponse> => {
  return customInstance<getOrgPromptResponse>(
    getGetOrgPromptUrl(orgId, promptType),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetOrgPromptQueryKey = (
  orgId: string,
  promptType: PromptType,
) => {
  return [`/api/v1/admin/prompts/orgs/${orgId}/${promptType}`] as const;
};

export const getGetOrgPromptQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgPrompt>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgPrompt>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrgPromptQueryKey(orgId, promptType);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgPrompt>>> = ({
    signal,
  }) => getOrgPrompt(orgId, promptType, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && promptType),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgPrompt>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgPromptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgPrompt>>
>;
export type GetOrgPromptQueryError = HTTPValidationError;

export function useGetOrgPrompt<
  TData = Awaited<ReturnType<typeof getOrgPrompt>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgPrompt>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgPrompt>>,
          TError,
          Awaited<ReturnType<typeof getOrgPrompt>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgPrompt<
  TData = Awaited<ReturnType<typeof getOrgPrompt>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgPrompt>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgPrompt>>,
          TError,
          Awaited<ReturnType<typeof getOrgPrompt>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgPrompt<
  TData = Awaited<ReturnType<typeof getOrgPrompt>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgPrompt>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Org Prompt
 */

export function useGetOrgPrompt<
  TData = Awaited<ReturnType<typeof getOrgPrompt>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgPrompt>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrgPromptQueryOptions(orgId, promptType, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create or update an org's prompt override.
 * @summary Update Org Prompt
 */
export type updateOrgPromptResponse200 = {
  data: Prompt;
  status: 200;
};

export type updateOrgPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateOrgPromptResponseSuccess = updateOrgPromptResponse200 & {
  headers: Headers;
};
export type updateOrgPromptResponseError = updateOrgPromptResponse422 & {
  headers: Headers;
};

export type updateOrgPromptResponse =
  | updateOrgPromptResponseSuccess
  | updateOrgPromptResponseError;

export const getUpdateOrgPromptUrl = (
  orgId: string,
  promptType: PromptType,
) => {
  return `/api/v1/admin/prompts/orgs/${orgId}/${promptType}`;
};

export const updateOrgPrompt = async (
  orgId: string,
  promptType: PromptType,
  promptUpdate: PromptUpdate,
  options?: RequestInit,
): Promise<updateOrgPromptResponse> => {
  return customInstance<updateOrgPromptResponse>(
    getUpdateOrgPromptUrl(orgId, promptType),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(promptUpdate),
    },
  );
};

export const getUpdateOrgPromptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOrgPrompt>>,
    TError,
    { orgId: string; promptType: PromptType; data: PromptUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOrgPrompt>>,
  TError,
  { orgId: string; promptType: PromptType; data: PromptUpdate },
  TContext
> => {
  const mutationKey = ["updateOrgPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOrgPrompt>>,
    { orgId: string; promptType: PromptType; data: PromptUpdate }
  > = (props) => {
    const { orgId, promptType, data } = props ?? {};

    return updateOrgPrompt(orgId, promptType, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOrgPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOrgPrompt>>
>;
export type UpdateOrgPromptMutationBody = PromptUpdate;
export type UpdateOrgPromptMutationError = HTTPValidationError;

/**
 * @summary Update Org Prompt
 */
export const useUpdateOrgPrompt = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateOrgPrompt>>,
      TError,
      { orgId: string; promptType: PromptType; data: PromptUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateOrgPrompt>>,
  TError,
  { orgId: string; promptType: PromptType; data: PromptUpdate },
  TContext
> => {
  return useMutation(getUpdateOrgPromptMutationOptions(options), queryClient);
};

/**
 * Delete an org's prompt override, reverting to default.
 * @summary Delete Org Prompt
 */
export type deleteOrgPromptResponse204 = {
  data: void;
  status: 204;
};

export type deleteOrgPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteOrgPromptResponseSuccess = deleteOrgPromptResponse204 & {
  headers: Headers;
};
export type deleteOrgPromptResponseError = deleteOrgPromptResponse422 & {
  headers: Headers;
};

export type deleteOrgPromptResponse =
  | deleteOrgPromptResponseSuccess
  | deleteOrgPromptResponseError;

export const getDeleteOrgPromptUrl = (
  orgId: string,
  promptType: PromptType,
) => {
  return `/api/v1/admin/prompts/orgs/${orgId}/${promptType}`;
};

export const deleteOrgPrompt = async (
  orgId: string,
  promptType: PromptType,
  options?: RequestInit,
): Promise<deleteOrgPromptResponse> => {
  return customInstance<deleteOrgPromptResponse>(
    getDeleteOrgPromptUrl(orgId, promptType),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteOrgPromptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteOrgPrompt>>,
    TError,
    { orgId: string; promptType: PromptType },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteOrgPrompt>>,
  TError,
  { orgId: string; promptType: PromptType },
  TContext
> => {
  const mutationKey = ["deleteOrgPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteOrgPrompt>>,
    { orgId: string; promptType: PromptType }
  > = (props) => {
    const { orgId, promptType } = props ?? {};

    return deleteOrgPrompt(orgId, promptType, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteOrgPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteOrgPrompt>>
>;

export type DeleteOrgPromptMutationError = HTTPValidationError;

/**
 * @summary Delete Org Prompt
 */
export const useDeleteOrgPrompt = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteOrgPrompt>>,
      TError,
      { orgId: string; promptType: PromptType },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteOrgPrompt>>,
  TError,
  { orgId: string; promptType: PromptType },
  TContext
> => {
  return useMutation(getDeleteOrgPromptMutationOptions(options), queryClient);
};

/**
 * Get version history for an org's prompt override.
 * @summary Get Org Prompt History
 */
export type getOrgPromptHistoryResponse200 = {
  data: PromptVersion[];
  status: 200;
};

export type getOrgPromptHistoryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrgPromptHistoryResponseSuccess =
  getOrgPromptHistoryResponse200 & {
    headers: Headers;
  };
export type getOrgPromptHistoryResponseError =
  getOrgPromptHistoryResponse422 & {
    headers: Headers;
  };

export type getOrgPromptHistoryResponse =
  | getOrgPromptHistoryResponseSuccess
  | getOrgPromptHistoryResponseError;

export const getGetOrgPromptHistoryUrl = (
  orgId: string,
  promptType: PromptType,
) => {
  return `/api/v1/admin/prompts/orgs/${orgId}/${promptType}/history`;
};

export const getOrgPromptHistory = async (
  orgId: string,
  promptType: PromptType,
  options?: RequestInit,
): Promise<getOrgPromptHistoryResponse> => {
  return customInstance<getOrgPromptHistoryResponse>(
    getGetOrgPromptHistoryUrl(orgId, promptType),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetOrgPromptHistoryQueryKey = (
  orgId: string,
  promptType: PromptType,
) => {
  return [`/api/v1/admin/prompts/orgs/${orgId}/${promptType}/history`] as const;
};

export const getGetOrgPromptHistoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgPromptHistory>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgPromptHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetOrgPromptHistoryQueryKey(orgId, promptType);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getOrgPromptHistory>>
  > = ({ signal }) =>
    getOrgPromptHistory(orgId, promptType, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && promptType),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgPromptHistory>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgPromptHistoryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgPromptHistory>>
>;
export type GetOrgPromptHistoryQueryError = HTTPValidationError;

export function useGetOrgPromptHistory<
  TData = Awaited<ReturnType<typeof getOrgPromptHistory>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgPromptHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgPromptHistory>>,
          TError,
          Awaited<ReturnType<typeof getOrgPromptHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgPromptHistory<
  TData = Awaited<ReturnType<typeof getOrgPromptHistory>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgPromptHistory>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgPromptHistory>>,
          TError,
          Awaited<ReturnType<typeof getOrgPromptHistory>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgPromptHistory<
  TData = Awaited<ReturnType<typeof getOrgPromptHistory>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgPromptHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Org Prompt History
 */

export function useGetOrgPromptHistory<
  TData = Awaited<ReturnType<typeof getOrgPromptHistory>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  promptType: PromptType,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getOrgPromptHistory>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrgPromptHistoryQueryOptions(
    orgId,
    promptType,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Rollback an org's prompt override to a specific version.
 * @summary Rollback Org Prompt
 */
export type rollbackOrgPromptResponse200 = {
  data: Prompt;
  status: 200;
};

export type rollbackOrgPromptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type rollbackOrgPromptResponseSuccess = rollbackOrgPromptResponse200 & {
  headers: Headers;
};
export type rollbackOrgPromptResponseError = rollbackOrgPromptResponse422 & {
  headers: Headers;
};

export type rollbackOrgPromptResponse =
  | rollbackOrgPromptResponseSuccess
  | rollbackOrgPromptResponseError;

export const getRollbackOrgPromptUrl = (
  orgId: string,
  promptType: PromptType,
  version: number,
) => {
  return `/api/v1/admin/prompts/orgs/${orgId}/${promptType}/rollback/${version}`;
};

export const rollbackOrgPrompt = async (
  orgId: string,
  promptType: PromptType,
  version: number,
  options?: RequestInit,
): Promise<rollbackOrgPromptResponse> => {
  return customInstance<rollbackOrgPromptResponse>(
    getRollbackOrgPromptUrl(orgId, promptType, version),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getRollbackOrgPromptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rollbackOrgPrompt>>,
    TError,
    { orgId: string; promptType: PromptType; version: number },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rollbackOrgPrompt>>,
  TError,
  { orgId: string; promptType: PromptType; version: number },
  TContext
> => {
  const mutationKey = ["rollbackOrgPrompt"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rollbackOrgPrompt>>,
    { orgId: string; promptType: PromptType; version: number }
  > = (props) => {
    const { orgId, promptType, version } = props ?? {};

    return rollbackOrgPrompt(orgId, promptType, version, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RollbackOrgPromptMutationResult = NonNullable<
  Awaited<ReturnType<typeof rollbackOrgPrompt>>
>;

export type RollbackOrgPromptMutationError = HTTPValidationError;

/**
 * @summary Rollback Org Prompt
 */
export const useRollbackOrgPrompt = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rollbackOrgPrompt>>,
      TError,
      { orgId: string; promptType: PromptType; version: number },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rollbackOrgPrompt>>,
  TError,
  { orgId: string; promptType: PromptType; version: number },
  TContext
> => {
  return useMutation(getRollbackOrgPromptMutationOptions(options), queryClient);
};

/**
 * List all organizations with pagination and optional name filter.
 * @summary Admin List Organizations
 */
export type adminListOrganizationsResponse200 = {
  data: AdminOrgListResponse;
  status: 200;
};

export type adminListOrganizationsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type adminListOrganizationsResponseSuccess =
  adminListOrganizationsResponse200 & {
    headers: Headers;
  };
export type adminListOrganizationsResponseError =
  adminListOrganizationsResponse422 & {
    headers: Headers;
  };

export type adminListOrganizationsResponse =
  | adminListOrganizationsResponseSuccess
  | adminListOrganizationsResponseError;

export const getAdminListOrganizationsUrl = (
  params?: AdminListOrganizationsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/organizations?${stringifiedParams}`
    : `/api/v1/admin/organizations`;
};

export const adminListOrganizations = async (
  params?: AdminListOrganizationsParams,
  options?: RequestInit,
): Promise<adminListOrganizationsResponse> => {
  return customInstance<adminListOrganizationsResponse>(
    getAdminListOrganizationsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminListOrganizationsQueryKey = (
  params?: AdminListOrganizationsParams,
) => {
  return [`/api/v1/admin/organizations`, ...(params ? [params] : [])] as const;
};

export const getAdminListOrganizationsQueryOptions = <
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = HTTPValidationError,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminListOrganizationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminListOrganizations>>
  > = ({ signal }) =>
    adminListOrganizations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminListOrganizations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminListOrganizationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminListOrganizations>>
>;
export type AdminListOrganizationsQueryError = HTTPValidationError;

export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = HTTPValidationError,
>(
  params: undefined | AdminListOrganizationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = HTTPValidationError,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminListOrganizations>>,
          TError,
          Awaited<ReturnType<typeof adminListOrganizations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = HTTPValidationError,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin List Organizations
 */

export function useAdminListOrganizations<
  TData = Awaited<ReturnType<typeof adminListOrganizations>>,
  TError = HTTPValidationError,
>(
  params?: AdminListOrganizationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminListOrganizations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdminListOrganizationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create an organization and assign an existing user as owner (super admin only).

The acting super-admin is never reassigned. If the owner already belongs to another org, the
request must set ``reassign_owner`` to move them (409 ``OWNER_ALREADY_ASSIGNED`` otherwise; 409
``WOULD_ORPHAN_ORG`` if they are that org's only owner).
 * @summary Admin Create Organization
 */
export type adminCreateOrganizationResponse201 = {
  data: AdminOrgDetail;
  status: 201;
};

export type adminCreateOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type adminCreateOrganizationResponseSuccess =
  adminCreateOrganizationResponse201 & {
    headers: Headers;
  };
export type adminCreateOrganizationResponseError =
  adminCreateOrganizationResponse422 & {
    headers: Headers;
  };

export type adminCreateOrganizationResponse =
  | adminCreateOrganizationResponseSuccess
  | adminCreateOrganizationResponseError;

export const getAdminCreateOrganizationUrl = () => {
  return `/api/v1/admin/organizations`;
};

export const adminCreateOrganization = async (
  adminOrgCreate: AdminOrgCreate,
  options?: RequestInit,
): Promise<adminCreateOrganizationResponse> => {
  return customInstance<adminCreateOrganizationResponse>(
    getAdminCreateOrganizationUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminOrgCreate),
    },
  );
};

export const getAdminCreateOrganizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminCreateOrganization>>,
    TError,
    { data: AdminOrgCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminCreateOrganization>>,
  TError,
  { data: AdminOrgCreate },
  TContext
> => {
  const mutationKey = ["adminCreateOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminCreateOrganization>>,
    { data: AdminOrgCreate }
  > = (props) => {
    const { data } = props ?? {};

    return adminCreateOrganization(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCreateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminCreateOrganization>>
>;
export type AdminCreateOrganizationMutationBody = AdminOrgCreate;
export type AdminCreateOrganizationMutationError = HTTPValidationError;

/**
 * @summary Admin Create Organization
 */
export const useAdminCreateOrganization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminCreateOrganization>>,
      TError,
      { data: AdminOrgCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminCreateOrganization>>,
  TError,
  { data: AdminOrgCreate },
  TContext
> => {
  return useMutation(
    getAdminCreateOrganizationMutationOptions(options),
    queryClient,
  );
};

/**
 * Get organization detail with members and conversation count.
 * @summary Admin Get Organization
 */
export type adminGetOrganizationResponse200 = {
  data: AdminOrgDetail;
  status: 200;
};

export type adminGetOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type adminGetOrganizationResponseSuccess =
  adminGetOrganizationResponse200 & {
    headers: Headers;
  };
export type adminGetOrganizationResponseError =
  adminGetOrganizationResponse422 & {
    headers: Headers;
  };

export type adminGetOrganizationResponse =
  | adminGetOrganizationResponseSuccess
  | adminGetOrganizationResponseError;

export const getAdminGetOrganizationUrl = (orgId: string) => {
  return `/api/v1/admin/organizations/${orgId}`;
};

export const adminGetOrganization = async (
  orgId: string,
  options?: RequestInit,
): Promise<adminGetOrganizationResponse> => {
  return customInstance<adminGetOrganizationResponse>(
    getAdminGetOrganizationUrl(orgId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getAdminGetOrganizationQueryKey = (orgId: string) => {
  return [`/api/v1/admin/organizations/${orgId}`] as const;
};

export const getAdminGetOrganizationQueryOptions = <
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getAdminGetOrganizationQueryKey(orgId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof adminGetOrganization>>
  > = ({ signal }) =>
    adminGetOrganization(orgId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!orgId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof adminGetOrganization>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGetOrganizationQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminGetOrganization>>
>;
export type AdminGetOrganizationQueryError = HTTPValidationError;

export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminGetOrganization>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetOrganization>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminGetOrganization>>,
          TError,
          Awaited<ReturnType<typeof adminGetOrganization>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin Get Organization
 */

export function useAdminGetOrganization<
  TData = Awaited<ReturnType<typeof adminGetOrganization>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof adminGetOrganization>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdminGetOrganizationQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update organization settings (name, model, profile). Super admin only.
 * @summary Admin Update Organization
 */
export type adminUpdateOrganizationResponse200 = {
  data: AdminOrgDetail;
  status: 200;
};

export type adminUpdateOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type adminUpdateOrganizationResponseSuccess =
  adminUpdateOrganizationResponse200 & {
    headers: Headers;
  };
export type adminUpdateOrganizationResponseError =
  adminUpdateOrganizationResponse422 & {
    headers: Headers;
  };

export type adminUpdateOrganizationResponse =
  | adminUpdateOrganizationResponseSuccess
  | adminUpdateOrganizationResponseError;

export const getAdminUpdateOrganizationUrl = (orgId: string) => {
  return `/api/v1/admin/organizations/${orgId}`;
};

export const adminUpdateOrganization = async (
  orgId: string,
  organizationUpdate: OrganizationUpdate,
  options?: RequestInit,
): Promise<adminUpdateOrganizationResponse> => {
  return customInstance<adminUpdateOrganizationResponse>(
    getAdminUpdateOrganizationUrl(orgId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(organizationUpdate),
    },
  );
};

export const getAdminUpdateOrganizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminUpdateOrganization>>,
    TError,
    { orgId: string; data: OrganizationUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminUpdateOrganization>>,
  TError,
  { orgId: string; data: OrganizationUpdate },
  TContext
> => {
  const mutationKey = ["adminUpdateOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminUpdateOrganization>>,
    { orgId: string; data: OrganizationUpdate }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return adminUpdateOrganization(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUpdateOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminUpdateOrganization>>
>;
export type AdminUpdateOrganizationMutationBody = OrganizationUpdate;
export type AdminUpdateOrganizationMutationError = HTTPValidationError;

/**
 * @summary Admin Update Organization
 */
export const useAdminUpdateOrganization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminUpdateOrganization>>,
      TError,
      { orgId: string; data: OrganizationUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminUpdateOrganization>>,
  TError,
  { orgId: string; data: OrganizationUpdate },
  TContext
> => {
  return useMutation(
    getAdminUpdateOrganizationMutationOptions(options),
    queryClient,
  );
};

/**
 * Delete organization and cascade all subcollections.
 * @summary Admin Delete Organization
 */
export type adminDeleteOrganizationResponse204 = {
  data: void;
  status: 204;
};

export type adminDeleteOrganizationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type adminDeleteOrganizationResponseSuccess =
  adminDeleteOrganizationResponse204 & {
    headers: Headers;
  };
export type adminDeleteOrganizationResponseError =
  adminDeleteOrganizationResponse422 & {
    headers: Headers;
  };

export type adminDeleteOrganizationResponse =
  | adminDeleteOrganizationResponseSuccess
  | adminDeleteOrganizationResponseError;

export const getAdminDeleteOrganizationUrl = (orgId: string) => {
  return `/api/v1/admin/organizations/${orgId}`;
};

export const adminDeleteOrganization = async (
  orgId: string,
  options?: RequestInit,
): Promise<adminDeleteOrganizationResponse> => {
  return customInstance<adminDeleteOrganizationResponse>(
    getAdminDeleteOrganizationUrl(orgId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getAdminDeleteOrganizationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof adminDeleteOrganization>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof adminDeleteOrganization>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ["adminDeleteOrganization"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof adminDeleteOrganization>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return adminDeleteOrganization(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDeleteOrganizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof adminDeleteOrganization>>
>;

export type AdminDeleteOrganizationMutationError = HTTPValidationError;

/**
 * @summary Admin Delete Organization
 */
export const useAdminDeleteOrganization = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof adminDeleteOrganization>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof adminDeleteOrganization>>,
  TError,
  { orgId: string },
  TContext
> => {
  return useMutation(
    getAdminDeleteOrganizationMutationOptions(options),
    queryClient,
  );
};

/**
 * List all users with pagination and optional email/status filter.
 * @summary List Users
 */
export type listUsersResponse200 = {
  data: AdminUserListResponse;
  status: 200;
};

export type listUsersResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listUsersResponseSuccess = listUsersResponse200 & {
  headers: Headers;
};
export type listUsersResponseError = listUsersResponse422 & {
  headers: Headers;
};

export type listUsersResponse =
  | listUsersResponseSuccess
  | listUsersResponseError;

export const getListUsersUrl = (params?: ListUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/users?${stringifiedParams}`
    : `/api/v1/admin/users`;
};

export const listUsers = async (
  params?: ListUsersParams,
  options?: RequestInit,
): Promise<listUsersResponse> => {
  return customInstance<listUsersResponse>(getListUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getListUsersQueryKey = (params?: ListUsersParams) => {
  return [`/api/v1/admin/users`, ...(params ? [params] : [])] as const;
};

export const getListUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = HTTPValidationError,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listUsers>>> = ({
    signal,
  }) => listUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listUsers>>
>;
export type ListUsersQueryError = HTTPValidationError;

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = HTTPValidationError,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listUsers>>,
          TError,
          Awaited<ReturnType<typeof listUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = HTTPValidationError,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Users
 */

export function useListUsers<
  TData = Awaited<ReturnType<typeof listUsers>>,
  TError = HTTPValidationError,
>(
  params?: ListUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get user detail with org info and claims.
 * @summary Get User
 */
export type getUserResponse200 = {
  data: AdminUserDetail;
  status: 200;
};

export type getUserResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getUserResponseSuccess = getUserResponse200 & {
  headers: Headers;
};
export type getUserResponseError = getUserResponse422 & {
  headers: Headers;
};

export type getUserResponse = getUserResponseSuccess | getUserResponseError;

export const getGetUserUrl = (userId: string) => {
  return `/api/v1/admin/users/${userId}`;
};

export const getUser = async (
  userId: string,
  options?: RequestInit,
): Promise<getUserResponse> => {
  return customInstance<getUserResponse>(getGetUserUrl(userId), {
    ...options,
    method: "GET",
  });
};

export const getGetUserQueryKey = (userId: string) => {
  return [`/api/v1/admin/users/${userId}`] as const;
};

export const getGetUserQueryOptions = <
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserQueryKey(userId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUser>>> = ({
    signal,
  }) => getUser(userId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!userId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUser>>
>;
export type GetUserQueryError = HTTPValidationError;

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = HTTPValidationError,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUser>>,
          TError,
          Awaited<ReturnType<typeof getUser>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User
 */

export function useGetUser<
  TData = Awaited<ReturnType<typeof getUser>>,
  TError = HTTPValidationError,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUser>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update user's Firebase custom claims.
 * @summary Update User Claims
 */
export type updateUserClaimsResponse200 = {
  data: AdminUserDetail;
  status: 200;
};

export type updateUserClaimsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateUserClaimsResponseSuccess = updateUserClaimsResponse200 & {
  headers: Headers;
};
export type updateUserClaimsResponseError = updateUserClaimsResponse422 & {
  headers: Headers;
};

export type updateUserClaimsResponse =
  | updateUserClaimsResponseSuccess
  | updateUserClaimsResponseError;

export const getUpdateUserClaimsUrl = (userId: string) => {
  return `/api/v1/admin/users/${userId}/claims`;
};

export const updateUserClaims = async (
  userId: string,
  adminClaimsUpdate: AdminClaimsUpdate,
  options?: RequestInit,
): Promise<updateUserClaimsResponse> => {
  return customInstance<updateUserClaimsResponse>(
    getUpdateUserClaimsUrl(userId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminClaimsUpdate),
    },
  );
};

export const getUpdateUserClaimsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateUserClaims>>,
    TError,
    { userId: string; data: AdminClaimsUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateUserClaims>>,
  TError,
  { userId: string; data: AdminClaimsUpdate },
  TContext
> => {
  const mutationKey = ["updateUserClaims"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateUserClaims>>,
    { userId: string; data: AdminClaimsUpdate }
  > = (props) => {
    const { userId, data } = props ?? {};

    return updateUserClaims(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateUserClaimsMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateUserClaims>>
>;
export type UpdateUserClaimsMutationBody = AdminClaimsUpdate;
export type UpdateUserClaimsMutationError = HTTPValidationError;

/**
 * @summary Update User Claims
 */
export const useUpdateUserClaims = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateUserClaims>>,
      TError,
      { userId: string; data: AdminClaimsUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateUserClaims>>,
  TError,
  { userId: string; data: AdminClaimsUpdate },
  TContext
> => {
  return useMutation(getUpdateUserClaimsMutationOptions(options), queryClient);
};

/**
 * Approve a pending user and assign to an organization.
 * @summary Approve User
 */
export type approveUserResponse200 = {
  data: AdminUserDetail;
  status: 200;
};

export type approveUserResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type approveUserResponseSuccess = approveUserResponse200 & {
  headers: Headers;
};
export type approveUserResponseError = approveUserResponse422 & {
  headers: Headers;
};

export type approveUserResponse =
  | approveUserResponseSuccess
  | approveUserResponseError;

export const getApproveUserUrl = (userId: string) => {
  return `/api/v1/admin/users/${userId}/approve`;
};

export const approveUser = async (
  userId: string,
  adminApproveRequest: AdminApproveRequest,
  options?: RequestInit,
): Promise<approveUserResponse> => {
  return customInstance<approveUserResponse>(getApproveUserUrl(userId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminApproveRequest),
  });
};

export const getApproveUserMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveUser>>,
    TError,
    { userId: string; data: AdminApproveRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveUser>>,
  TError,
  { userId: string; data: AdminApproveRequest },
  TContext
> => {
  const mutationKey = ["approveUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveUser>>,
    { userId: string; data: AdminApproveRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return approveUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveUser>>
>;
export type ApproveUserMutationBody = AdminApproveRequest;
export type ApproveUserMutationError = HTTPValidationError;

/**
 * @summary Approve User
 */
export const useApproveUser = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof approveUser>>,
      TError,
      { userId: string; data: AdminApproveRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof approveUser>>,
  TError,
  { userId: string; data: AdminApproveRequest },
  TContext
> => {
  return useMutation(getApproveUserMutationOptions(options), queryClient);
};

/**
 * Reject a pending user.
 * @summary Reject User
 */
export type rejectUserResponse200 = {
  data: AdminUserDetail;
  status: 200;
};

export type rejectUserResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type rejectUserResponseSuccess = rejectUserResponse200 & {
  headers: Headers;
};
export type rejectUserResponseError = rejectUserResponse422 & {
  headers: Headers;
};

export type rejectUserResponse =
  | rejectUserResponseSuccess
  | rejectUserResponseError;

export const getRejectUserUrl = (userId: string) => {
  return `/api/v1/admin/users/${userId}/reject`;
};

export const rejectUser = async (
  userId: string,
  adminRejectRequest: AdminRejectRequest,
  options?: RequestInit,
): Promise<rejectUserResponse> => {
  return customInstance<rejectUserResponse>(getRejectUserUrl(userId), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(adminRejectRequest),
  });
};

export const getRejectUserMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof rejectUser>>,
    TError,
    { userId: string; data: AdminRejectRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof rejectUser>>,
  TError,
  { userId: string; data: AdminRejectRequest },
  TContext
> => {
  const mutationKey = ["rejectUser"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof rejectUser>>,
    { userId: string; data: AdminRejectRequest }
  > = (props) => {
    const { userId, data } = props ?? {};

    return rejectUser(userId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RejectUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof rejectUser>>
>;
export type RejectUserMutationBody = AdminRejectRequest;
export type RejectUserMutationError = HTTPValidationError;

/**
 * @summary Reject User
 */
export const useRejectUser = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof rejectUser>>,
      TError,
      { userId: string; data: AdminRejectRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof rejectUser>>,
  TError,
  { userId: string; data: AdminRejectRequest },
  TContext
> => {
  return useMutation(getRejectUserMutationOptions(options), queryClient);
};

/**
 * Extended health check with service statuses and system stats.
 * @summary Admin Health
 */
export type adminHealthResponse200 = {
  data: AdminHealthResponse;
  status: 200;
};

export type adminHealthResponseSuccess = adminHealthResponse200 & {
  headers: Headers;
};
export type adminHealthResponse = adminHealthResponseSuccess;

export const getAdminHealthUrl = () => {
  return `/api/v1/admin/health`;
};

export const adminHealth = async (
  options?: RequestInit,
): Promise<adminHealthResponse> => {
  return customInstance<adminHealthResponse>(getAdminHealthUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAdminHealthQueryKey = () => {
  return [`/api/v1/admin/health`] as const;
};

export const getAdminHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof adminHealth>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof adminHealth>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof adminHealth>>> = ({
    signal,
  }) => adminHealth({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof adminHealth>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminHealthQueryResult = NonNullable<
  Awaited<ReturnType<typeof adminHealth>>
>;
export type AdminHealthQueryError = unknown;

export function useAdminHealth<
  TData = Awaited<ReturnType<typeof adminHealth>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminHealth>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminHealth>>,
          TError,
          Awaited<ReturnType<typeof adminHealth>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminHealth<
  TData = Awaited<ReturnType<typeof adminHealth>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminHealth>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof adminHealth>>,
          TError,
          Awaited<ReturnType<typeof adminHealth>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useAdminHealth<
  TData = Awaited<ReturnType<typeof adminHealth>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminHealth>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Admin Health
 */

export function useAdminHealth<
  TData = Awaited<ReturnType<typeof adminHealth>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof adminHealth>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getAdminHealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List all files in the system knowledge base.
 * @summary Kb List Files
 */
export type kbListFilesResponse200 = {
  data: FileResponse[];
  status: 200;
};

export type kbListFilesResponseSuccess = kbListFilesResponse200 & {
  headers: Headers;
};
export type kbListFilesResponse = kbListFilesResponseSuccess;

export const getKbListFilesUrl = () => {
  return `/api/v1/admin/knowledge-base/files`;
};

export const kbListFiles = async (
  options?: RequestInit,
): Promise<kbListFilesResponse> => {
  return customInstance<kbListFilesResponse>(getKbListFilesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getKbListFilesQueryKey = () => {
  return [`/api/v1/admin/knowledge-base/files`] as const;
};

export const getKbListFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof kbListFiles>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof kbListFiles>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getKbListFilesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof kbListFiles>>> = ({
    signal,
  }) => kbListFiles({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof kbListFiles>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type KbListFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof kbListFiles>>
>;
export type KbListFilesQueryError = unknown;

export function useKbListFiles<
  TData = Awaited<ReturnType<typeof kbListFiles>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof kbListFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof kbListFiles>>,
          TError,
          Awaited<ReturnType<typeof kbListFiles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKbListFiles<
  TData = Awaited<ReturnType<typeof kbListFiles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof kbListFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof kbListFiles>>,
          TError,
          Awaited<ReturnType<typeof kbListFiles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useKbListFiles<
  TData = Awaited<ReturnType<typeof kbListFiles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof kbListFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Kb List Files
 */

export function useKbListFiles<
  TData = Awaited<ReturnType<typeof kbListFiles>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof kbListFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getKbListFilesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a file record and trigger background indexing.
 * @summary Kb Create File
 */
export type kbCreateFileResponse201 = {
  data: FileResponse;
  status: 201;
};

export type kbCreateFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type kbCreateFileResponseSuccess = kbCreateFileResponse201 & {
  headers: Headers;
};
export type kbCreateFileResponseError = kbCreateFileResponse422 & {
  headers: Headers;
};

export type kbCreateFileResponse =
  | kbCreateFileResponseSuccess
  | kbCreateFileResponseError;

export const getKbCreateFileUrl = () => {
  return `/api/v1/admin/knowledge-base/files`;
};

export const kbCreateFile = async (
  fileCreate: FileCreate,
  options?: RequestInit,
): Promise<kbCreateFileResponse> => {
  return customInstance<kbCreateFileResponse>(getKbCreateFileUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(fileCreate),
  });
};

export const getKbCreateFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof kbCreateFile>>,
    TError,
    { data: FileCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof kbCreateFile>>,
  TError,
  { data: FileCreate },
  TContext
> => {
  const mutationKey = ["kbCreateFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof kbCreateFile>>,
    { data: FileCreate }
  > = (props) => {
    const { data } = props ?? {};

    return kbCreateFile(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KbCreateFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof kbCreateFile>>
>;
export type KbCreateFileMutationBody = FileCreate;
export type KbCreateFileMutationError = HTTPValidationError;

/**
 * @summary Kb Create File
 */
export const useKbCreateFile = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof kbCreateFile>>,
      TError,
      { data: FileCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof kbCreateFile>>,
  TError,
  { data: FileCreate },
  TContext
> => {
  return useMutation(getKbCreateFileMutationOptions(options), queryClient);
};

/**
 * Get a signed GCS upload URL for a system KB file.
 * @summary Kb Get Upload Url
 */
export type kbGetUploadUrlResponse200 = {
  data: UploadUrlResponse;
  status: 200;
};

export type kbGetUploadUrlResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type kbGetUploadUrlResponseSuccess = kbGetUploadUrlResponse200 & {
  headers: Headers;
};
export type kbGetUploadUrlResponseError = kbGetUploadUrlResponse422 & {
  headers: Headers;
};

export type kbGetUploadUrlResponse =
  | kbGetUploadUrlResponseSuccess
  | kbGetUploadUrlResponseError;

export const getKbGetUploadUrlUrl = () => {
  return `/api/v1/admin/knowledge-base/upload-url`;
};

export const kbGetUploadUrl = async (
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<kbGetUploadUrlResponse> => {
  return customInstance<kbGetUploadUrlResponse>(getKbGetUploadUrlUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getKbGetUploadUrlMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof kbGetUploadUrl>>,
    TError,
    { data: UploadUrlRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof kbGetUploadUrl>>,
  TError,
  { data: UploadUrlRequest },
  TContext
> => {
  const mutationKey = ["kbGetUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof kbGetUploadUrl>>,
    { data: UploadUrlRequest }
  > = (props) => {
    const { data } = props ?? {};

    return kbGetUploadUrl(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KbGetUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof kbGetUploadUrl>>
>;
export type KbGetUploadUrlMutationBody = UploadUrlRequest;
export type KbGetUploadUrlMutationError = HTTPValidationError;

/**
 * @summary Kb Get Upload Url
 */
export const useKbGetUploadUrl = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof kbGetUploadUrl>>,
      TError,
      { data: UploadUrlRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof kbGetUploadUrl>>,
  TError,
  { data: UploadUrlRequest },
  TContext
> => {
  return useMutation(getKbGetUploadUrlMutationOptions(options), queryClient);
};

/**
 * Delete a file and all its index data.
 * @summary Kb Delete File
 */
export type kbDeleteFileResponse204 = {
  data: void;
  status: 204;
};

export type kbDeleteFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type kbDeleteFileResponseSuccess = kbDeleteFileResponse204 & {
  headers: Headers;
};
export type kbDeleteFileResponseError = kbDeleteFileResponse422 & {
  headers: Headers;
};

export type kbDeleteFileResponse =
  | kbDeleteFileResponseSuccess
  | kbDeleteFileResponseError;

export const getKbDeleteFileUrl = (fileId: string) => {
  return `/api/v1/admin/knowledge-base/files/${fileId}`;
};

export const kbDeleteFile = async (
  fileId: string,
  options?: RequestInit,
): Promise<kbDeleteFileResponse> => {
  return customInstance<kbDeleteFileResponse>(getKbDeleteFileUrl(fileId), {
    ...options,
    method: "DELETE",
  });
};

export const getKbDeleteFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof kbDeleteFile>>,
    TError,
    { fileId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof kbDeleteFile>>,
  TError,
  { fileId: string },
  TContext
> => {
  const mutationKey = ["kbDeleteFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof kbDeleteFile>>,
    { fileId: string }
  > = (props) => {
    const { fileId } = props ?? {};

    return kbDeleteFile(fileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KbDeleteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof kbDeleteFile>>
>;

export type KbDeleteFileMutationError = HTTPValidationError;

/**
 * @summary Kb Delete File
 */
export const useKbDeleteFile = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof kbDeleteFile>>,
      TError,
      { fileId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof kbDeleteFile>>,
  TError,
  { fileId: string },
  TContext
> => {
  return useMutation(getKbDeleteFileMutationOptions(options), queryClient);
};

/**
 * Re-index a file.
 * @summary Kb Reindex File
 */
export type kbReindexFileResponse200 = {
  data: FileResponse;
  status: 200;
};

export type kbReindexFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type kbReindexFileResponseSuccess = kbReindexFileResponse200 & {
  headers: Headers;
};
export type kbReindexFileResponseError = kbReindexFileResponse422 & {
  headers: Headers;
};

export type kbReindexFileResponse =
  | kbReindexFileResponseSuccess
  | kbReindexFileResponseError;

export const getKbReindexFileUrl = (fileId: string) => {
  return `/api/v1/admin/knowledge-base/files/${fileId}/reindex`;
};

export const kbReindexFile = async (
  fileId: string,
  options?: RequestInit,
): Promise<kbReindexFileResponse> => {
  return customInstance<kbReindexFileResponse>(getKbReindexFileUrl(fileId), {
    ...options,
    method: "POST",
  });
};

export const getKbReindexFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof kbReindexFile>>,
    TError,
    { fileId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof kbReindexFile>>,
  TError,
  { fileId: string },
  TContext
> => {
  const mutationKey = ["kbReindexFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof kbReindexFile>>,
    { fileId: string }
  > = (props) => {
    const { fileId } = props ?? {};

    return kbReindexFile(fileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type KbReindexFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof kbReindexFile>>
>;

export type KbReindexFileMutationError = HTTPValidationError;

/**
 * @summary Kb Reindex File
 */
export const useKbReindexFile = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof kbReindexFile>>,
      TError,
      { fileId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof kbReindexFile>>,
  TError,
  { fileId: string },
  TContext
> => {
  return useMutation(getKbReindexFileMutationOptions(options), queryClient);
};

/**
 * Non-streaming LLM generation.
 * @summary Generate
 */
export type generateResponse200 = {
  data: GenerateResponse;
  status: 200;
};

export type generateResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type generateResponseSuccess = generateResponse200 & {
  headers: Headers;
};
export type generateResponseError = generateResponse422 & {
  headers: Headers;
};

export type generateResponse = generateResponseSuccess | generateResponseError;

export const getGenerateUrl = () => {
  return `/api/v1/chat/generate`;
};

export const generate = async (
  generateRequest: GenerateRequest,
  options?: RequestInit,
): Promise<generateResponse> => {
  return customInstance<generateResponse>(getGenerateUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateRequest),
  });
};

export const getGenerateMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generate>>,
    TError,
    { data: GenerateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generate>>,
  TError,
  { data: GenerateRequest },
  TContext
> => {
  const mutationKey = ["generate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generate>>,
    { data: GenerateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return generate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GenerateMutationResult = NonNullable<
  Awaited<ReturnType<typeof generate>>
>;
export type GenerateMutationBody = GenerateRequest;
export type GenerateMutationError = HTTPValidationError;

/**
 * @summary Generate
 */
export const useGenerate = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof generate>>,
      TError,
      { data: GenerateRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof generate>>,
  TError,
  { data: GenerateRequest },
  TContext
> => {
  return useMutation(getGenerateMutationOptions(options), queryClient);
};

/**
 * Streaming LLM generation via Server-Sent Events.
 * @summary Stream
 */
export type streamResponse200 = {
  data: unknown;
  status: 200;
};

export type streamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type streamResponseSuccess = streamResponse200 & {
  headers: Headers;
};
export type streamResponseError = streamResponse422 & {
  headers: Headers;
};

export type streamResponse = streamResponseSuccess | streamResponseError;

export const getStreamUrl = () => {
  return `/api/v1/chat/stream`;
};

export const stream = async (
  generateRequest: GenerateRequest,
  options?: RequestInit,
): Promise<streamResponse> => {
  return customInstance<streamResponse>(getStreamUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(generateRequest),
  });
};

export const getStreamMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof stream>>,
    TError,
    { data: GenerateRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof stream>>,
  TError,
  { data: GenerateRequest },
  TContext
> => {
  const mutationKey = ["stream"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof stream>>,
    { data: GenerateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return stream(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StreamMutationResult = NonNullable<
  Awaited<ReturnType<typeof stream>>
>;
export type StreamMutationBody = GenerateRequest;
export type StreamMutationError = HTTPValidationError;

/**
 * @summary Stream
 */
export const useStream = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof stream>>,
      TError,
      { data: GenerateRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof stream>>,
  TError,
  { data: GenerateRequest },
  TContext
> => {
  return useMutation(getStreamMutationOptions(options), queryClient);
};

/**
 * List available LLM models.
 * @summary List Chat Models
 */
export type listChatModelsResponse200 = {
  data: ModelInfo[];
  status: 200;
};

export type listChatModelsResponseSuccess = listChatModelsResponse200 & {
  headers: Headers;
};
export type listChatModelsResponse = listChatModelsResponseSuccess;

export const getListChatModelsUrl = () => {
  return `/api/v1/chat/models`;
};

export const listChatModels = async (
  options?: RequestInit,
): Promise<listChatModelsResponse> => {
  return customInstance<listChatModelsResponse>(getListChatModelsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListChatModelsQueryKey = () => {
  return [`/api/v1/chat/models`] as const;
};

export const getListChatModelsQueryOptions = <
  TData = Awaited<ReturnType<typeof listChatModels>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listChatModels>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListChatModelsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listChatModels>>> = ({
    signal,
  }) => listChatModels({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listChatModels>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListChatModelsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listChatModels>>
>;
export type ListChatModelsQueryError = unknown;

export function useListChatModels<
  TData = Awaited<ReturnType<typeof listChatModels>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChatModels>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChatModels>>,
          TError,
          Awaited<ReturnType<typeof listChatModels>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListChatModels<
  TData = Awaited<ReturnType<typeof listChatModels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChatModels>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listChatModels>>,
          TError,
          Awaited<ReturnType<typeof listChatModels>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListChatModels<
  TData = Awaited<ReturnType<typeof listChatModels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChatModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Chat Models
 */

export function useListChatModels<
  TData = Awaited<ReturnType<typeof listChatModels>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listChatModels>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListChatModelsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Count tokens in text.
 * @summary Count Tokens
 */
export type countTokensResponse200 = {
  data: CountTokensResponse;
  status: 200;
};

export type countTokensResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type countTokensResponseSuccess = countTokensResponse200 & {
  headers: Headers;
};
export type countTokensResponseError = countTokensResponse422 & {
  headers: Headers;
};

export type countTokensResponse =
  | countTokensResponseSuccess
  | countTokensResponseError;

export const getCountTokensUrl = () => {
  return `/api/v1/chat/count-tokens`;
};

export const countTokens = async (
  countTokensRequest: CountTokensRequest,
  options?: RequestInit,
): Promise<countTokensResponse> => {
  return customInstance<countTokensResponse>(getCountTokensUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(countTokensRequest),
  });
};

export const getCountTokensMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof countTokens>>,
    TError,
    { data: CountTokensRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof countTokens>>,
  TError,
  { data: CountTokensRequest },
  TContext
> => {
  const mutationKey = ["countTokens"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof countTokens>>,
    { data: CountTokensRequest }
  > = (props) => {
    const { data } = props ?? {};

    return countTokens(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CountTokensMutationResult = NonNullable<
  Awaited<ReturnType<typeof countTokens>>
>;
export type CountTokensMutationBody = CountTokensRequest;
export type CountTokensMutationError = HTTPValidationError;

/**
 * @summary Count Tokens
 */
export const useCountTokens = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof countTokens>>,
      TError,
      { data: CountTokensRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof countTokens>>,
  TError,
  { data: CountTokensRequest },
  TContext
> => {
  return useMutation(getCountTokensMutationOptions(options), queryClient);
};

/**
 * Create a new conversation.
 * @summary Create Conversation
 */
export type createConversationResponse201 = {
  data: ConversationResponse;
  status: 201;
};

export type createConversationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createConversationResponseSuccess =
  createConversationResponse201 & {
    headers: Headers;
  };
export type createConversationResponseError = createConversationResponse422 & {
  headers: Headers;
};

export type createConversationResponse =
  | createConversationResponseSuccess
  | createConversationResponseError;

export const getCreateConversationUrl = () => {
  return `/api/v1/conversations`;
};

export const createConversation = async (
  conversationCreate: ConversationCreate,
  options?: RequestInit,
): Promise<createConversationResponse> => {
  return customInstance<createConversationResponse>(
    getCreateConversationUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(conversationCreate),
    },
  );
};

export const getCreateConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createConversation>>,
    TError,
    { data: ConversationCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { data: ConversationCreate },
  TContext
> => {
  const mutationKey = ["createConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createConversation>>,
    { data: ConversationCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createConversation(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof createConversation>>
>;
export type CreateConversationMutationBody = ConversationCreate;
export type CreateConversationMutationError = HTTPValidationError;

/**
 * @summary Create Conversation
 */
export const useCreateConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createConversation>>,
      TError,
      { data: ConversationCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createConversation>>,
  TError,
  { data: ConversationCreate },
  TContext
> => {
  return useMutation(
    getCreateConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * List conversations for the current organization.
 * @summary List Conversations
 */
export type listConversationsResponse200 = {
  data: ConversationResponse[];
  status: 200;
};

export type listConversationsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listConversationsResponseSuccess = listConversationsResponse200 & {
  headers: Headers;
};
export type listConversationsResponseError = listConversationsResponse422 & {
  headers: Headers;
};

export type listConversationsResponse =
  | listConversationsResponseSuccess
  | listConversationsResponseError;

export const getListConversationsUrl = (params?: ListConversationsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/conversations?${stringifiedParams}`
    : `/api/v1/conversations`;
};

export const listConversations = async (
  params?: ListConversationsParams,
  options?: RequestInit,
): Promise<listConversationsResponse> => {
  return customInstance<listConversationsResponse>(
    getListConversationsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListConversationsQueryKey = (
  params?: ListConversationsParams,
) => {
  return [`/api/v1/conversations`, ...(params ? [params] : [])] as const;
};

export const getListConversationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListConversationsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listConversations>>
  > = ({ signal }) => listConversations(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listConversations>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListConversationsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listConversations>>
>;
export type ListConversationsQueryError = HTTPValidationError;

export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListConversationsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversations>>,
          TError,
          Awaited<ReturnType<typeof listConversations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConversations>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listConversations>>,
          TError,
          Awaited<ReturnType<typeof listConversations>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Conversations
 */

export function useListConversations<
  TData = Awaited<ReturnType<typeof listConversations>>,
  TError = HTTPValidationError,
>(
  params?: ListConversationsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listConversations>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListConversationsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Add tags to multiple conversations at once.
 * @summary Bulk Tag Conversations
 */
export type bulkTagConversationsResponse200 = {
  data: BulkTagResponse;
  status: 200;
};

export type bulkTagConversationsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type bulkTagConversationsResponseSuccess =
  bulkTagConversationsResponse200 & {
    headers: Headers;
  };
export type bulkTagConversationsResponseError =
  bulkTagConversationsResponse422 & {
    headers: Headers;
  };

export type bulkTagConversationsResponse =
  | bulkTagConversationsResponseSuccess
  | bulkTagConversationsResponseError;

export const getBulkTagConversationsUrl = () => {
  return `/api/v1/conversations/bulk-tag`;
};

export const bulkTagConversations = async (
  bulkTagRequest: BulkTagRequest,
  options?: RequestInit,
): Promise<bulkTagConversationsResponse> => {
  return customInstance<bulkTagConversationsResponse>(
    getBulkTagConversationsUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(bulkTagRequest),
    },
  );
};

export const getBulkTagConversationsMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkTagConversations>>,
    TError,
    { data: BulkTagRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof bulkTagConversations>>,
  TError,
  { data: BulkTagRequest },
  TContext
> => {
  const mutationKey = ["bulkTagConversations"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkTagConversations>>,
    { data: BulkTagRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkTagConversations(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkTagConversationsMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkTagConversations>>
>;
export type BulkTagConversationsMutationBody = BulkTagRequest;
export type BulkTagConversationsMutationError = HTTPValidationError;

/**
 * @summary Bulk Tag Conversations
 */
export const useBulkTagConversations = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof bulkTagConversations>>,
      TError,
      { data: BulkTagRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof bulkTagConversations>>,
  TError,
  { data: BulkTagRequest },
  TContext
> => {
  return useMutation(
    getBulkTagConversationsMutationOptions(options),
    queryClient,
  );
};

/**
 * Get a conversation with all its messages.
 * @summary Get Conversation
 */
export type getConversationResponse200 = {
  data: ConversationDetail;
  status: 200;
};

export type getConversationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getConversationResponseSuccess = getConversationResponse200 & {
  headers: Headers;
};
export type getConversationResponseError = getConversationResponse422 & {
  headers: Headers;
};

export type getConversationResponse =
  | getConversationResponseSuccess
  | getConversationResponseError;

export const getGetConversationUrl = (conversationId: string) => {
  return `/api/v1/conversations/${conversationId}`;
};

export const getConversation = async (
  conversationId: string,
  options?: RequestInit,
): Promise<getConversationResponse> => {
  return customInstance<getConversationResponse>(
    getGetConversationUrl(conversationId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetConversationQueryKey = (conversationId: string) => {
  return [`/api/v1/conversations/${conversationId}`] as const;
};

export const getGetConversationQueryOptions = <
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetConversationQueryKey(conversationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getConversation>>> = ({
    signal,
  }) => getConversation(conversationId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!conversationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getConversation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetConversationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getConversation>>
>;
export type GetConversationQueryError = HTTPValidationError;

export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getConversation>>,
          TError,
          Awaited<ReturnType<typeof getConversation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Conversation
 */

export function useGetConversation<
  TData = Awaited<ReturnType<typeof getConversation>>,
  TError = HTTPValidationError,
>(
  conversationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getConversation>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetConversationQueryOptions(conversationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Delete a conversation and all its messages.
 * @summary Delete Conversation
 */
export type deleteConversationResponse204 = {
  data: void;
  status: 204;
};

export type deleteConversationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteConversationResponseSuccess =
  deleteConversationResponse204 & {
    headers: Headers;
  };
export type deleteConversationResponseError = deleteConversationResponse422 & {
  headers: Headers;
};

export type deleteConversationResponse =
  | deleteConversationResponseSuccess
  | deleteConversationResponseError;

export const getDeleteConversationUrl = (conversationId: string) => {
  return `/api/v1/conversations/${conversationId}`;
};

export const deleteConversation = async (
  conversationId: string,
  options?: RequestInit,
): Promise<deleteConversationResponse> => {
  return customInstance<deleteConversationResponse>(
    getDeleteConversationUrl(conversationId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteConversation>>,
    TError,
    { conversationId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteConversation>>,
  TError,
  { conversationId: string },
  TContext
> => {
  const mutationKey = ["deleteConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteConversation>>,
    { conversationId: string }
  > = (props) => {
    const { conversationId } = props ?? {};

    return deleteConversation(conversationId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteConversation>>
>;

export type DeleteConversationMutationError = HTTPValidationError;

/**
 * @summary Delete Conversation
 */
export const useDeleteConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteConversation>>,
      TError,
      { conversationId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteConversation>>,
  TError,
  { conversationId: string },
  TContext
> => {
  return useMutation(
    getDeleteConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * Update conversation title and/or tags.
 * @summary Update Conversation
 */
export type updateConversationResponse200 = {
  data: ConversationResponse;
  status: 200;
};

export type updateConversationResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateConversationResponseSuccess =
  updateConversationResponse200 & {
    headers: Headers;
  };
export type updateConversationResponseError = updateConversationResponse422 & {
  headers: Headers;
};

export type updateConversationResponse =
  | updateConversationResponseSuccess
  | updateConversationResponseError;

export const getUpdateConversationUrl = (conversationId: string) => {
  return `/api/v1/conversations/${conversationId}`;
};

export const updateConversation = async (
  conversationId: string,
  conversationUpdate: ConversationUpdate,
  options?: RequestInit,
): Promise<updateConversationResponse> => {
  return customInstance<updateConversationResponse>(
    getUpdateConversationUrl(conversationId),
    {
      ...options,
      method: "PATCH",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(conversationUpdate),
    },
  );
};

export const getUpdateConversationMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateConversation>>,
    TError,
    { conversationId: string; data: ConversationUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateConversation>>,
  TError,
  { conversationId: string; data: ConversationUpdate },
  TContext
> => {
  const mutationKey = ["updateConversation"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateConversation>>,
    { conversationId: string; data: ConversationUpdate }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return updateConversation(conversationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateConversationMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateConversation>>
>;
export type UpdateConversationMutationBody = ConversationUpdate;
export type UpdateConversationMutationError = HTTPValidationError;

/**
 * @summary Update Conversation
 */
export const useUpdateConversation = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateConversation>>,
      TError,
      { conversationId: string; data: ConversationUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateConversation>>,
  TError,
  { conversationId: string; data: ConversationUpdate },
  TContext
> => {
  return useMutation(
    getUpdateConversationMutationOptions(options),
    queryClient,
  );
};

/**
 * Send a message and stream the LLM response via SSE.
 * @summary Send Message
 */
export type sendMessageResponse200 = {
  data: unknown;
  status: 200;
};

export type sendMessageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type sendMessageResponseSuccess = sendMessageResponse200 & {
  headers: Headers;
};
export type sendMessageResponseError = sendMessageResponse422 & {
  headers: Headers;
};

export type sendMessageResponse =
  | sendMessageResponseSuccess
  | sendMessageResponseError;

export const getSendMessageUrl = (conversationId: string) => {
  return `/api/v1/conversations/${conversationId}/messages`;
};

export const sendMessage = async (
  conversationId: string,
  messageCreate: MessageCreate,
  options?: RequestInit,
): Promise<sendMessageResponse> => {
  return customInstance<sendMessageResponse>(
    getSendMessageUrl(conversationId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(messageCreate),
    },
  );
};

export const getSendMessageMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendMessage>>,
    TError,
    { conversationId: string; data: MessageCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { conversationId: string; data: MessageCreate },
  TContext
> => {
  const mutationKey = ["sendMessage"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendMessage>>,
    { conversationId: string; data: MessageCreate }
  > = (props) => {
    const { conversationId, data } = props ?? {};

    return sendMessage(conversationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendMessageMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendMessage>>
>;
export type SendMessageMutationBody = MessageCreate;
export type SendMessageMutationError = HTTPValidationError;

/**
 * @summary Send Message
 */
export const useSendMessage = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof sendMessage>>,
      TError,
      { conversationId: string; data: MessageCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof sendMessage>>,
  TError,
  { conversationId: string; data: MessageCreate },
  TContext
> => {
  return useMutation(getSendMessageMutationOptions(options), queryClient);
};

/**
 * Upload a transcript file and extract text content.
 * @summary Upload Transcript
 */
export type uploadTranscriptResponse200 = {
  data: TranscriptUploadResponse;
  status: 200;
};

export type uploadTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadTranscriptResponseSuccess = uploadTranscriptResponse200 & {
  headers: Headers;
};
export type uploadTranscriptResponseError = uploadTranscriptResponse422 & {
  headers: Headers;
};

export type uploadTranscriptResponse =
  | uploadTranscriptResponseSuccess
  | uploadTranscriptResponseError;

export const getUploadTranscriptUrl = () => {
  return `/api/v1/conversations/upload-transcript`;
};

export const uploadTranscript = async (
  bodyUploadTranscript: BodyUploadTranscript,
  options?: RequestInit,
): Promise<uploadTranscriptResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadTranscript.file);

  return customInstance<uploadTranscriptResponse>(getUploadTranscriptUrl(), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadTranscriptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadTranscript>>,
    TError,
    { data: BodyUploadTranscript },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadTranscript>>,
  TError,
  { data: BodyUploadTranscript },
  TContext
> => {
  const mutationKey = ["uploadTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadTranscript>>,
    { data: BodyUploadTranscript }
  > = (props) => {
    const { data } = props ?? {};

    return uploadTranscript(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadTranscript>>
>;
export type UploadTranscriptMutationBody = BodyUploadTranscript;
export type UploadTranscriptMutationError = HTTPValidationError;

/**
 * @summary Upload Transcript
 */
export const useUploadTranscript = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadTranscript>>,
      TError,
      { data: BodyUploadTranscript },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadTranscript>>,
  TError,
  { data: BodyUploadTranscript },
  TContext
> => {
  return useMutation(getUploadTranscriptMutationOptions(options), queryClient);
};

/**
 * List all tags used in the organization with usage counts.
 * @summary List Tags
 */
export type listTagsResponse200 = {
  data: TagCount[];
  status: 200;
};

export type listTagsResponseSuccess = listTagsResponse200 & {
  headers: Headers;
};
export type listTagsResponse = listTagsResponseSuccess;

export const getListTagsUrl = () => {
  return `/api/v1/tags`;
};

export const listTags = async (
  options?: RequestInit,
): Promise<listTagsResponse> => {
  return customInstance<listTagsResponse>(getListTagsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListTagsQueryKey = () => {
  return [`/api/v1/tags`] as const;
};

export const getListTagsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTags>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTagsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTags>>> = ({
    signal,
  }) => listTags({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTags>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTagsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTags>>
>;
export type ListTagsQueryError = unknown;

export function useListTags<
  TData = Awaited<ReturnType<typeof listTags>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTags>>,
          TError,
          Awaited<ReturnType<typeof listTags>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTags<
  TData = Awaited<ReturnType<typeof listTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTags>>,
          TError,
          Awaited<ReturnType<typeof listTags>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTags<
  TData = Awaited<ReturnType<typeof listTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Tags
 */

export function useListTags<
  TData = Awaited<ReturnType<typeof listTags>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTags>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTagsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List all teams in an organization.
 * @summary List Teams
 */
export type listTeamsResponse200 = {
  data: Team[];
  status: 200;
};

export type listTeamsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTeamsResponseSuccess = listTeamsResponse200 & {
  headers: Headers;
};
export type listTeamsResponseError = listTeamsResponse422 & {
  headers: Headers;
};

export type listTeamsResponse =
  | listTeamsResponseSuccess
  | listTeamsResponseError;

export const getListTeamsUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}/teams`;
};

export const listTeams = async (
  orgId: string,
  options?: RequestInit,
): Promise<listTeamsResponse> => {
  return customInstance<listTeamsResponse>(getListTeamsUrl(orgId), {
    ...options,
    method: "GET",
  });
};

export const getListTeamsQueryKey = (orgId: string) => {
  return [`/api/v1/organizations/${orgId}/teams`] as const;
};

export const getListTeamsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTeamsQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTeams>>> = ({
    signal,
  }) => listTeams(orgId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!orgId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListTeamsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTeams>>
>;
export type ListTeamsQueryError = HTTPValidationError;

export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeams>>,
          TError,
          Awaited<ReturnType<typeof listTeams>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTeams>>,
          TError,
          Awaited<ReturnType<typeof listTeams>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Teams
 */

export function useListTeams<
  TData = Awaited<ReturnType<typeof listTeams>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listTeams>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTeamsQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a team. Requires org_owner+ role.
 * @summary Create Team
 */
export type createTeamResponse201 = {
  data: Team;
  status: 201;
};

export type createTeamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createTeamResponseSuccess = createTeamResponse201 & {
  headers: Headers;
};
export type createTeamResponseError = createTeamResponse422 & {
  headers: Headers;
};

export type createTeamResponse =
  | createTeamResponseSuccess
  | createTeamResponseError;

export const getCreateTeamUrl = (orgId: string) => {
  return `/api/v1/organizations/${orgId}/teams`;
};

export const createTeam = async (
  orgId: string,
  teamCreate: TeamCreate,
  options?: RequestInit,
): Promise<createTeamResponse> => {
  return customInstance<createTeamResponse>(getCreateTeamUrl(orgId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(teamCreate),
  });
};

export const getCreateTeamMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTeam>>,
    TError,
    { orgId: string; data: TeamCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTeam>>,
  TError,
  { orgId: string; data: TeamCreate },
  TContext
> => {
  const mutationKey = ["createTeam"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTeam>>,
    { orgId: string; data: TeamCreate }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return createTeam(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTeamMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTeam>>
>;
export type CreateTeamMutationBody = TeamCreate;
export type CreateTeamMutationError = HTTPValidationError;

/**
 * @summary Create Team
 */
export const useCreateTeam = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTeam>>,
      TError,
      { orgId: string; data: TeamCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTeam>>,
  TError,
  { orgId: string; data: TeamCreate },
  TContext
> => {
  return useMutation(getCreateTeamMutationOptions(options), queryClient);
};

/**
 * Get a team with its member + manager rosters.
 * @summary Get Team
 */
export type getTeamResponse200 = {
  data: TeamDetail;
  status: 200;
};

export type getTeamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTeamResponseSuccess = getTeamResponse200 & {
  headers: Headers;
};
export type getTeamResponseError = getTeamResponse422 & {
  headers: Headers;
};

export type getTeamResponse = getTeamResponseSuccess | getTeamResponseError;

export const getGetTeamUrl = (orgId: string, teamId: string) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}`;
};

export const getTeam = async (
  orgId: string,
  teamId: string,
  options?: RequestInit,
): Promise<getTeamResponse> => {
  return customInstance<getTeamResponse>(getGetTeamUrl(orgId, teamId), {
    ...options,
    method: "GET",
  });
};

export const getGetTeamQueryKey = (orgId: string, teamId: string) => {
  return [`/api/v1/organizations/${orgId}/teams/${teamId}`] as const;
};

export const getGetTeamQueryOptions = <
  TData = Awaited<ReturnType<typeof getTeam>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTeamQueryKey(orgId, teamId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTeam>>> = ({
    signal,
  }) => getTeam(orgId, teamId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(orgId && teamId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetTeamQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTeam>>
>;
export type GetTeamQueryError = HTTPValidationError;

export function useGetTeam<
  TData = Awaited<ReturnType<typeof getTeam>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  teamId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeam<
  TData = Awaited<ReturnType<typeof getTeam>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTeam>>,
          TError,
          Awaited<ReturnType<typeof getTeam>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTeam<
  TData = Awaited<ReturnType<typeof getTeam>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Team
 */

export function useGetTeam<
  TData = Awaited<ReturnType<typeof getTeam>>,
  TError = HTTPValidationError,
>(
  orgId: string,
  teamId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTeam>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTeamQueryOptions(orgId, teamId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update a team's name/description. Requires org_owner+ role.
 * @summary Update Team
 */
export type updateTeamResponse200 = {
  data: Team;
  status: 200;
};

export type updateTeamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateTeamResponseSuccess = updateTeamResponse200 & {
  headers: Headers;
};
export type updateTeamResponseError = updateTeamResponse422 & {
  headers: Headers;
};

export type updateTeamResponse =
  | updateTeamResponseSuccess
  | updateTeamResponseError;

export const getUpdateTeamUrl = (orgId: string, teamId: string) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}`;
};

export const updateTeam = async (
  orgId: string,
  teamId: string,
  teamUpdate: TeamUpdate,
  options?: RequestInit,
): Promise<updateTeamResponse> => {
  return customInstance<updateTeamResponse>(getUpdateTeamUrl(orgId, teamId), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(teamUpdate),
  });
};

export const getUpdateTeamMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTeam>>,
    TError,
    { orgId: string; teamId: string; data: TeamUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTeam>>,
  TError,
  { orgId: string; teamId: string; data: TeamUpdate },
  TContext
> => {
  const mutationKey = ["updateTeam"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTeam>>,
    { orgId: string; teamId: string; data: TeamUpdate }
  > = (props) => {
    const { orgId, teamId, data } = props ?? {};

    return updateTeam(orgId, teamId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTeamMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTeam>>
>;
export type UpdateTeamMutationBody = TeamUpdate;
export type UpdateTeamMutationError = HTTPValidationError;

/**
 * @summary Update Team
 */
export const useUpdateTeam = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTeam>>,
      TError,
      { orgId: string; teamId: string; data: TeamUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateTeam>>,
  TError,
  { orgId: string; teamId: string; data: TeamUpdate },
  TContext
> => {
  return useMutation(getUpdateTeamMutationOptions(options), queryClient);
};

/**
 * Delete a team. Requires org_owner+ role.
 * @summary Delete Team
 */
export type deleteTeamResponse204 = {
  data: void;
  status: 204;
};

export type deleteTeamResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteTeamResponseSuccess = deleteTeamResponse204 & {
  headers: Headers;
};
export type deleteTeamResponseError = deleteTeamResponse422 & {
  headers: Headers;
};

export type deleteTeamResponse =
  | deleteTeamResponseSuccess
  | deleteTeamResponseError;

export const getDeleteTeamUrl = (orgId: string, teamId: string) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}`;
};

export const deleteTeam = async (
  orgId: string,
  teamId: string,
  options?: RequestInit,
): Promise<deleteTeamResponse> => {
  return customInstance<deleteTeamResponse>(getDeleteTeamUrl(orgId, teamId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteTeamMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTeam>>,
    TError,
    { orgId: string; teamId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTeam>>,
  TError,
  { orgId: string; teamId: string },
  TContext
> => {
  const mutationKey = ["deleteTeam"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTeam>>,
    { orgId: string; teamId: string }
  > = (props) => {
    const { orgId, teamId } = props ?? {};

    return deleteTeam(orgId, teamId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTeamMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTeam>>
>;

export type DeleteTeamMutationError = HTTPValidationError;

/**
 * @summary Delete Team
 */
export const useDeleteTeam = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTeam>>,
      TError,
      { orgId: string; teamId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTeam>>,
  TError,
  { orgId: string; teamId: string },
  TContext
> => {
  return useMutation(getDeleteTeamMutationOptions(options), queryClient);
};

/**
 * Add a rep to a team. Requires org_owner+ role.
 * @summary Add Team Member
 */
export type addTeamMemberResponse204 = {
  data: void;
  status: 204;
};

export type addTeamMemberResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type addTeamMemberResponseSuccess = addTeamMemberResponse204 & {
  headers: Headers;
};
export type addTeamMemberResponseError = addTeamMemberResponse422 & {
  headers: Headers;
};

export type addTeamMemberResponse =
  | addTeamMemberResponseSuccess
  | addTeamMemberResponseError;

export const getAddTeamMemberUrl = (orgId: string, teamId: string) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}/members`;
};

export const addTeamMember = async (
  orgId: string,
  teamId: string,
  teamMemberAdd: TeamMemberAdd,
  options?: RequestInit,
): Promise<addTeamMemberResponse> => {
  return customInstance<addTeamMemberResponse>(
    getAddTeamMemberUrl(orgId, teamId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(teamMemberAdd),
    },
  );
};

export const getAddTeamMemberMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTeamMember>>,
    TError,
    { orgId: string; teamId: string; data: TeamMemberAdd },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTeamMember>>,
  TError,
  { orgId: string; teamId: string; data: TeamMemberAdd },
  TContext
> => {
  const mutationKey = ["addTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTeamMember>>,
    { orgId: string; teamId: string; data: TeamMemberAdd }
  > = (props) => {
    const { orgId, teamId, data } = props ?? {};

    return addTeamMember(orgId, teamId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTeamMember>>
>;
export type AddTeamMemberMutationBody = TeamMemberAdd;
export type AddTeamMemberMutationError = HTTPValidationError;

/**
 * @summary Add Team Member
 */
export const useAddTeamMember = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addTeamMember>>,
      TError,
      { orgId: string; teamId: string; data: TeamMemberAdd },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addTeamMember>>,
  TError,
  { orgId: string; teamId: string; data: TeamMemberAdd },
  TContext
> => {
  return useMutation(getAddTeamMemberMutationOptions(options), queryClient);
};

/**
 * Remove a rep from a team. Requires org_owner+ role.
 * @summary Remove Team Member
 */
export type removeTeamMemberResponse204 = {
  data: void;
  status: 204;
};

export type removeTeamMemberResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type removeTeamMemberResponseSuccess = removeTeamMemberResponse204 & {
  headers: Headers;
};
export type removeTeamMemberResponseError = removeTeamMemberResponse422 & {
  headers: Headers;
};

export type removeTeamMemberResponse =
  | removeTeamMemberResponseSuccess
  | removeTeamMemberResponseError;

export const getRemoveTeamMemberUrl = (
  orgId: string,
  teamId: string,
  uid: string,
) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}/members/${uid}`;
};

export const removeTeamMember = async (
  orgId: string,
  teamId: string,
  uid: string,
  options?: RequestInit,
): Promise<removeTeamMemberResponse> => {
  return customInstance<removeTeamMemberResponse>(
    getRemoveTeamMemberUrl(orgId, teamId, uid),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getRemoveTeamMemberMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeTeamMember>>,
    TError,
    { orgId: string; teamId: string; uid: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeTeamMember>>,
  TError,
  { orgId: string; teamId: string; uid: string },
  TContext
> => {
  const mutationKey = ["removeTeamMember"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeTeamMember>>,
    { orgId: string; teamId: string; uid: string }
  > = (props) => {
    const { orgId, teamId, uid } = props ?? {};

    return removeTeamMember(orgId, teamId, uid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveTeamMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof removeTeamMember>>
>;

export type RemoveTeamMemberMutationError = HTTPValidationError;

/**
 * @summary Remove Team Member
 */
export const useRemoveTeamMember = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeTeamMember>>,
      TError,
      { orgId: string; teamId: string; uid: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeTeamMember>>,
  TError,
  { orgId: string; teamId: string; uid: string },
  TContext
> => {
  return useMutation(getRemoveTeamMemberMutationOptions(options), queryClient);
};

/**
 * Assign a manager (sales_manager+) to a team. Requires org_owner+ role.
 * @summary Assign Team Manager
 */
export type assignTeamManagerResponse204 = {
  data: void;
  status: 204;
};

export type assignTeamManagerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type assignTeamManagerResponseSuccess = assignTeamManagerResponse204 & {
  headers: Headers;
};
export type assignTeamManagerResponseError = assignTeamManagerResponse422 & {
  headers: Headers;
};

export type assignTeamManagerResponse =
  | assignTeamManagerResponseSuccess
  | assignTeamManagerResponseError;

export const getAssignTeamManagerUrl = (orgId: string, teamId: string) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}/managers`;
};

export const assignTeamManager = async (
  orgId: string,
  teamId: string,
  teamMemberAdd: TeamMemberAdd,
  options?: RequestInit,
): Promise<assignTeamManagerResponse> => {
  return customInstance<assignTeamManagerResponse>(
    getAssignTeamManagerUrl(orgId, teamId),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(teamMemberAdd),
    },
  );
};

export const getAssignTeamManagerMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof assignTeamManager>>,
    TError,
    { orgId: string; teamId: string; data: TeamMemberAdd },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof assignTeamManager>>,
  TError,
  { orgId: string; teamId: string; data: TeamMemberAdd },
  TContext
> => {
  const mutationKey = ["assignTeamManager"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof assignTeamManager>>,
    { orgId: string; teamId: string; data: TeamMemberAdd }
  > = (props) => {
    const { orgId, teamId, data } = props ?? {};

    return assignTeamManager(orgId, teamId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AssignTeamManagerMutationResult = NonNullable<
  Awaited<ReturnType<typeof assignTeamManager>>
>;
export type AssignTeamManagerMutationBody = TeamMemberAdd;
export type AssignTeamManagerMutationError = HTTPValidationError;

/**
 * @summary Assign Team Manager
 */
export const useAssignTeamManager = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof assignTeamManager>>,
      TError,
      { orgId: string; teamId: string; data: TeamMemberAdd },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof assignTeamManager>>,
  TError,
  { orgId: string; teamId: string; data: TeamMemberAdd },
  TContext
> => {
  return useMutation(getAssignTeamManagerMutationOptions(options), queryClient);
};

/**
 * Unassign a manager from a team. Requires org_owner+ role.
 * @summary Unassign Team Manager
 */
export type unassignTeamManagerResponse204 = {
  data: void;
  status: 204;
};

export type unassignTeamManagerResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type unassignTeamManagerResponseSuccess =
  unassignTeamManagerResponse204 & {
    headers: Headers;
  };
export type unassignTeamManagerResponseError =
  unassignTeamManagerResponse422 & {
    headers: Headers;
  };

export type unassignTeamManagerResponse =
  | unassignTeamManagerResponseSuccess
  | unassignTeamManagerResponseError;

export const getUnassignTeamManagerUrl = (
  orgId: string,
  teamId: string,
  uid: string,
) => {
  return `/api/v1/organizations/${orgId}/teams/${teamId}/managers/${uid}`;
};

export const unassignTeamManager = async (
  orgId: string,
  teamId: string,
  uid: string,
  options?: RequestInit,
): Promise<unassignTeamManagerResponse> => {
  return customInstance<unassignTeamManagerResponse>(
    getUnassignTeamManagerUrl(orgId, teamId, uid),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getUnassignTeamManagerMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof unassignTeamManager>>,
    TError,
    { orgId: string; teamId: string; uid: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof unassignTeamManager>>,
  TError,
  { orgId: string; teamId: string; uid: string },
  TContext
> => {
  const mutationKey = ["unassignTeamManager"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unassignTeamManager>>,
    { orgId: string; teamId: string; uid: string }
  > = (props) => {
    const { orgId, teamId, uid } = props ?? {};

    return unassignTeamManager(orgId, teamId, uid, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnassignTeamManagerMutationResult = NonNullable<
  Awaited<ReturnType<typeof unassignTeamManager>>
>;

export type UnassignTeamManagerMutationError = HTTPValidationError;

/**
 * @summary Unassign Team Manager
 */
export const useUnassignTeamManager = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof unassignTeamManager>>,
      TError,
      { orgId: string; teamId: string; uid: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof unassignTeamManager>>,
  TError,
  { orgId: string; teamId: string; uid: string },
  TContext
> => {
  return useMutation(
    getUnassignTeamManagerMutationOptions(options),
    queryClient,
  );
};

/**
 * List vector stores the user is entitled to see (personal-first; spec 039).

Returns Org KBs, the viewer's Team KBs, and the viewer's *own* Individual KBs. Another user's
Individual KB is never returned here — even for an owner/manager/super-admin (cross-user
visibility for reporting is out of scope; see spec 041).
 * @summary List Vector Stores
 */
export type listVectorStoresResponse200 = {
  data: VectorStoreResponse[];
  status: 200;
};

export type listVectorStoresResponseSuccess = listVectorStoresResponse200 & {
  headers: Headers;
};
export type listVectorStoresResponse = listVectorStoresResponseSuccess;

export const getListVectorStoresUrl = () => {
  return `/api/v1/vector-stores`;
};

export const listVectorStores = async (
  options?: RequestInit,
): Promise<listVectorStoresResponse> => {
  return customInstance<listVectorStoresResponse>(getListVectorStoresUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListVectorStoresQueryKey = () => {
  return [`/api/v1/vector-stores`] as const;
};

export const getListVectorStoresQueryOptions = <
  TData = Awaited<ReturnType<typeof listVectorStores>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof listVectorStores>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListVectorStoresQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listVectorStores>>
  > = ({ signal }) => listVectorStores({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listVectorStores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListVectorStoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof listVectorStores>>
>;
export type ListVectorStoresQueryError = unknown;

export function useListVectorStores<
  TData = Awaited<ReturnType<typeof listVectorStores>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVectorStores>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVectorStores>>,
          TError,
          Awaited<ReturnType<typeof listVectorStores>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListVectorStores<
  TData = Awaited<ReturnType<typeof listVectorStores>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVectorStores>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listVectorStores>>,
          TError,
          Awaited<ReturnType<typeof listVectorStores>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListVectorStores<
  TData = Awaited<ReturnType<typeof listVectorStores>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVectorStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Vector Stores
 */

export function useListVectorStores<
  TData = Awaited<ReturnType<typeof listVectorStores>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listVectorStores>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListVectorStoresQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a new vector store (knowledge base) at the requested scope.
 * @summary Create Vector Store
 */
export type createVectorStoreResponse201 = {
  data: VectorStoreResponse;
  status: 201;
};

export type createVectorStoreResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createVectorStoreResponseSuccess = createVectorStoreResponse201 & {
  headers: Headers;
};
export type createVectorStoreResponseError = createVectorStoreResponse422 & {
  headers: Headers;
};

export type createVectorStoreResponse =
  | createVectorStoreResponseSuccess
  | createVectorStoreResponseError;

export const getCreateVectorStoreUrl = () => {
  return `/api/v1/vector-stores`;
};

export const createVectorStore = async (
  vectorStoreCreate: VectorStoreCreate,
  options?: RequestInit,
): Promise<createVectorStoreResponse> => {
  return customInstance<createVectorStoreResponse>(getCreateVectorStoreUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vectorStoreCreate),
  });
};

export const getCreateVectorStoreMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVectorStore>>,
    TError,
    { data: VectorStoreCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVectorStore>>,
  TError,
  { data: VectorStoreCreate },
  TContext
> => {
  const mutationKey = ["createVectorStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVectorStore>>,
    { data: VectorStoreCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createVectorStore(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVectorStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVectorStore>>
>;
export type CreateVectorStoreMutationBody = VectorStoreCreate;
export type CreateVectorStoreMutationError = HTTPValidationError;

/**
 * @summary Create Vector Store
 */
export const useCreateVectorStore = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createVectorStore>>,
      TError,
      { data: VectorStoreCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createVectorStore>>,
  TError,
  { data: VectorStoreCreate },
  TContext
> => {
  return useMutation(getCreateVectorStoreMutationOptions(options), queryClient);
};

/**
 * Get a vector store by ID.
 * @summary Get Vector Store
 */
export type getVectorStoreResponse200 = {
  data: VectorStoreResponse;
  status: 200;
};

export type getVectorStoreResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getVectorStoreResponseSuccess = getVectorStoreResponse200 & {
  headers: Headers;
};
export type getVectorStoreResponseError = getVectorStoreResponse422 & {
  headers: Headers;
};

export type getVectorStoreResponse =
  | getVectorStoreResponseSuccess
  | getVectorStoreResponseError;

export const getGetVectorStoreUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}`;
};

export const getVectorStore = async (
  storeId: string,
  options?: RequestInit,
): Promise<getVectorStoreResponse> => {
  return customInstance<getVectorStoreResponse>(getGetVectorStoreUrl(storeId), {
    ...options,
    method: "GET",
  });
};

export const getGetVectorStoreQueryKey = (storeId: string) => {
  return [`/api/v1/vector-stores/${storeId}`] as const;
};

export const getGetVectorStoreQueryOptions = <
  TData = Awaited<ReturnType<typeof getVectorStore>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVectorStore>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVectorStoreQueryKey(storeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVectorStore>>> = ({
    signal,
  }) => getVectorStore(storeId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!storeId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getVectorStore>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVectorStoreQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVectorStore>>
>;
export type GetVectorStoreQueryError = HTTPValidationError;

export function useGetVectorStore<
  TData = Awaited<ReturnType<typeof getVectorStore>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVectorStore>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVectorStore>>,
          TError,
          Awaited<ReturnType<typeof getVectorStore>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVectorStore<
  TData = Awaited<ReturnType<typeof getVectorStore>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVectorStore>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVectorStore>>,
          TError,
          Awaited<ReturnType<typeof getVectorStore>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVectorStore<
  TData = Awaited<ReturnType<typeof getVectorStore>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVectorStore>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Vector Store
 */

export function useGetVectorStore<
  TData = Awaited<ReturnType<typeof getVectorStore>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVectorStore>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVectorStoreQueryOptions(storeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Update a vector store's name or description.
 * @summary Update Vector Store
 */
export type updateVectorStoreResponse200 = {
  data: VectorStoreResponse;
  status: 200;
};

export type updateVectorStoreResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type updateVectorStoreResponseSuccess = updateVectorStoreResponse200 & {
  headers: Headers;
};
export type updateVectorStoreResponseError = updateVectorStoreResponse422 & {
  headers: Headers;
};

export type updateVectorStoreResponse =
  | updateVectorStoreResponseSuccess
  | updateVectorStoreResponseError;

export const getUpdateVectorStoreUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}`;
};

export const updateVectorStore = async (
  storeId: string,
  vectorStoreUpdate: VectorStoreUpdate,
  options?: RequestInit,
): Promise<updateVectorStoreResponse> => {
  return customInstance<updateVectorStoreResponse>(
    getUpdateVectorStoreUrl(storeId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(vectorStoreUpdate),
    },
  );
};

export const getUpdateVectorStoreMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVectorStore>>,
    TError,
    { storeId: string; data: VectorStoreUpdate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVectorStore>>,
  TError,
  { storeId: string; data: VectorStoreUpdate },
  TContext
> => {
  const mutationKey = ["updateVectorStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVectorStore>>,
    { storeId: string; data: VectorStoreUpdate }
  > = (props) => {
    const { storeId, data } = props ?? {};

    return updateVectorStore(storeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVectorStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVectorStore>>
>;
export type UpdateVectorStoreMutationBody = VectorStoreUpdate;
export type UpdateVectorStoreMutationError = HTTPValidationError;

/**
 * @summary Update Vector Store
 */
export const useUpdateVectorStore = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateVectorStore>>,
      TError,
      { storeId: string; data: VectorStoreUpdate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateVectorStore>>,
  TError,
  { storeId: string; data: VectorStoreUpdate },
  TContext
> => {
  return useMutation(getUpdateVectorStoreMutationOptions(options), queryClient);
};

/**
 * Delete a vector store and all its files, chunks, and embeddings.
 * @summary Delete Vector Store
 */
export type deleteVectorStoreResponse204 = {
  data: void;
  status: 204;
};

export type deleteVectorStoreResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteVectorStoreResponseSuccess = deleteVectorStoreResponse204 & {
  headers: Headers;
};
export type deleteVectorStoreResponseError = deleteVectorStoreResponse422 & {
  headers: Headers;
};

export type deleteVectorStoreResponse =
  | deleteVectorStoreResponseSuccess
  | deleteVectorStoreResponseError;

export const getDeleteVectorStoreUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}`;
};

export const deleteVectorStore = async (
  storeId: string,
  options?: RequestInit,
): Promise<deleteVectorStoreResponse> => {
  return customInstance<deleteVectorStoreResponse>(
    getDeleteVectorStoreUrl(storeId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteVectorStoreMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteVectorStore>>,
    TError,
    { storeId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteVectorStore>>,
  TError,
  { storeId: string },
  TContext
> => {
  const mutationKey = ["deleteVectorStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteVectorStore>>,
    { storeId: string }
  > = (props) => {
    const { storeId } = props ?? {};

    return deleteVectorStore(storeId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteVectorStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteVectorStore>>
>;

export type DeleteVectorStoreMutationError = HTTPValidationError;

/**
 * @summary Delete Vector Store
 */
export const useDeleteVectorStore = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteVectorStore>>,
      TError,
      { storeId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteVectorStore>>,
  TError,
  { storeId: string },
  TContext
> => {
  return useMutation(getDeleteVectorStoreMutationOptions(options), queryClient);
};

/**
 * Get a signed GCS upload URL for a file.
 * @summary Get Upload Url
 */
export type getUploadUrlResponse200 = {
  data: UploadUrlResponse;
  status: 200;
};

export type getUploadUrlResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getUploadUrlResponseSuccess = getUploadUrlResponse200 & {
  headers: Headers;
};
export type getUploadUrlResponseError = getUploadUrlResponse422 & {
  headers: Headers;
};

export type getUploadUrlResponse =
  | getUploadUrlResponseSuccess
  | getUploadUrlResponseError;

export const getGetUploadUrlUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}/upload-url`;
};

export const getUploadUrl = async (
  storeId: string,
  uploadUrlRequest: UploadUrlRequest,
  options?: RequestInit,
): Promise<getUploadUrlResponse> => {
  return customInstance<getUploadUrlResponse>(getGetUploadUrlUrl(storeId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(uploadUrlRequest),
  });
};

export const getGetUploadUrlMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getUploadUrl>>,
    TError,
    { storeId: string; data: UploadUrlRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getUploadUrl>>,
  TError,
  { storeId: string; data: UploadUrlRequest },
  TContext
> => {
  const mutationKey = ["getUploadUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUploadUrl>>,
    { storeId: string; data: UploadUrlRequest }
  > = (props) => {
    const { storeId, data } = props ?? {};

    return getUploadUrl(storeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUploadUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getUploadUrl>>
>;
export type GetUploadUrlMutationBody = UploadUrlRequest;
export type GetUploadUrlMutationError = HTTPValidationError;

/**
 * @summary Get Upload Url
 */
export const useGetUploadUrl = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getUploadUrl>>,
      TError,
      { storeId: string; data: UploadUrlRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof getUploadUrl>>,
  TError,
  { storeId: string; data: UploadUrlRequest },
  TContext
> => {
  return useMutation(getGetUploadUrlMutationOptions(options), queryClient);
};

/**
 * Create a file record and trigger background indexing.
 * @summary Create File
 */
export type createFileResponse201 = {
  data: FileResponse;
  status: 201;
};

export type createFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createFileResponseSuccess = createFileResponse201 & {
  headers: Headers;
};
export type createFileResponseError = createFileResponse422 & {
  headers: Headers;
};

export type createFileResponse =
  | createFileResponseSuccess
  | createFileResponseError;

export const getCreateFileUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}/files`;
};

export const createFile = async (
  storeId: string,
  fileCreate: FileCreate,
  options?: RequestInit,
): Promise<createFileResponse> => {
  return customInstance<createFileResponse>(getCreateFileUrl(storeId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(fileCreate),
  });
};

export const getCreateFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createFile>>,
    TError,
    { storeId: string; data: FileCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createFile>>,
  TError,
  { storeId: string; data: FileCreate },
  TContext
> => {
  const mutationKey = ["createFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createFile>>,
    { storeId: string; data: FileCreate }
  > = (props) => {
    const { storeId, data } = props ?? {};

    return createFile(storeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof createFile>>
>;
export type CreateFileMutationBody = FileCreate;
export type CreateFileMutationError = HTTPValidationError;

/**
 * @summary Create File
 */
export const useCreateFile = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createFile>>,
      TError,
      { storeId: string; data: FileCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createFile>>,
  TError,
  { storeId: string; data: FileCreate },
  TContext
> => {
  return useMutation(getCreateFileMutationOptions(options), queryClient);
};

/**
 * List all files in a vector store.
 * @summary List Files
 */
export type listFilesResponse200 = {
  data: FileResponse[];
  status: 200;
};

export type listFilesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listFilesResponseSuccess = listFilesResponse200 & {
  headers: Headers;
};
export type listFilesResponseError = listFilesResponse422 & {
  headers: Headers;
};

export type listFilesResponse =
  | listFilesResponseSuccess
  | listFilesResponseError;

export const getListFilesUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}/files`;
};

export const listFiles = async (
  storeId: string,
  options?: RequestInit,
): Promise<listFilesResponse> => {
  return customInstance<listFilesResponse>(getListFilesUrl(storeId), {
    ...options,
    method: "GET",
  });
};

export const getListFilesQueryKey = (storeId: string) => {
  return [`/api/v1/vector-stores/${storeId}/files`] as const;
};

export const getListFilesQueryOptions = <
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListFilesQueryKey(storeId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listFiles>>> = ({
    signal,
  }) => listFiles(storeId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!storeId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type ListFilesQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFiles>>
>;
export type ListFilesQueryError = HTTPValidationError;

export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFiles>>,
          TError,
          Awaited<ReturnType<typeof listFiles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFiles>>,
          TError,
          Awaited<ReturnType<typeof listFiles>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Files
 */

export function useListFiles<
  TData = Awaited<ReturnType<typeof listFiles>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof listFiles>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListFilesQueryOptions(storeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Add a free-form text entry to a vector store and index it (spec 040).

No GCS file — the content is chunked + embedded directly. The file record is synthetic
(``storage_path=""``). Authorized like file management (individual KB → owning rep).
 * @summary Add Text Entry
 */
export type addTextEntryResponse201 = {
  data: FileResponse;
  status: 201;
};

export type addTextEntryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type addTextEntryResponseSuccess = addTextEntryResponse201 & {
  headers: Headers;
};
export type addTextEntryResponseError = addTextEntryResponse422 & {
  headers: Headers;
};

export type addTextEntryResponse =
  | addTextEntryResponseSuccess
  | addTextEntryResponseError;

export const getAddTextEntryUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}/text`;
};

export const addTextEntry = async (
  storeId: string,
  addTextRequest: AddTextRequest,
  options?: RequestInit,
): Promise<addTextEntryResponse> => {
  return customInstance<addTextEntryResponse>(getAddTextEntryUrl(storeId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(addTextRequest),
  });
};

export const getAddTextEntryMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addTextEntry>>,
    TError,
    { storeId: string; data: AddTextRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addTextEntry>>,
  TError,
  { storeId: string; data: AddTextRequest },
  TContext
> => {
  const mutationKey = ["addTextEntry"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addTextEntry>>,
    { storeId: string; data: AddTextRequest }
  > = (props) => {
    const { storeId, data } = props ?? {};

    return addTextEntry(storeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddTextEntryMutationResult = NonNullable<
  Awaited<ReturnType<typeof addTextEntry>>
>;
export type AddTextEntryMutationBody = AddTextRequest;
export type AddTextEntryMutationError = HTTPValidationError;

/**
 * @summary Add Text Entry
 */
export const useAddTextEntry = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addTextEntry>>,
      TError,
      { storeId: string; data: AddTextRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addTextEntry>>,
  TError,
  { storeId: string; data: AddTextRequest },
  TContext
> => {
  return useMutation(getAddTextEntryMutationOptions(options), queryClient);
};

/**
 * Upload a file directly and trigger background indexing.
 * @summary Upload File
 */
export type uploadFileResponse201 = {
  data: FileResponse;
  status: 201;
};

export type uploadFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadFileResponseSuccess = uploadFileResponse201 & {
  headers: Headers;
};
export type uploadFileResponseError = uploadFileResponse422 & {
  headers: Headers;
};

export type uploadFileResponse =
  | uploadFileResponseSuccess
  | uploadFileResponseError;

export const getUploadFileUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}/upload`;
};

export const uploadFile = async (
  storeId: string,
  bodyUploadFile: BodyUploadFile,
  options?: RequestInit,
): Promise<uploadFileResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadFile.file);

  return customInstance<uploadFileResponse>(getUploadFileUrl(storeId), {
    ...options,
    method: "POST",
    body: formData,
  });
};

export const getUploadFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadFile>>,
    TError,
    { storeId: string; data: BodyUploadFile },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { storeId: string; data: BodyUploadFile },
  TContext
> => {
  const mutationKey = ["uploadFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadFile>>,
    { storeId: string; data: BodyUploadFile }
  > = (props) => {
    const { storeId, data } = props ?? {};

    return uploadFile(storeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadFile>>
>;
export type UploadFileMutationBody = BodyUploadFile;
export type UploadFileMutationError = HTTPValidationError;

/**
 * @summary Upload File
 */
export const useUploadFile = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadFile>>,
      TError,
      { storeId: string; data: BodyUploadFile },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadFile>>,
  TError,
  { storeId: string; data: BodyUploadFile },
  TContext
> => {
  return useMutation(getUploadFileMutationOptions(options), queryClient);
};

/**
 * Get a file's details.
 * @summary Get File
 */
export type getFileResponse200 = {
  data: FileResponse;
  status: 200;
};

export type getFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getFileResponseSuccess = getFileResponse200 & {
  headers: Headers;
};
export type getFileResponseError = getFileResponse422 & {
  headers: Headers;
};

export type getFileResponse = getFileResponseSuccess | getFileResponseError;

export const getGetFileUrl = (storeId: string, fileId: string) => {
  return `/api/v1/vector-stores/${storeId}/files/${fileId}`;
};

export const getFile = async (
  storeId: string,
  fileId: string,
  options?: RequestInit,
): Promise<getFileResponse> => {
  return customInstance<getFileResponse>(getGetFileUrl(storeId, fileId), {
    ...options,
    method: "GET",
  });
};

export const getGetFileQueryKey = (storeId: string, fileId: string) => {
  return [`/api/v1/vector-stores/${storeId}/files/${fileId}`] as const;
};

export const getGetFileQueryOptions = <
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetFileQueryKey(storeId, fileId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFile>>> = ({
    signal,
  }) => getFile(storeId, fileId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(storeId && fileId),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFile>>
>;
export type GetFileQueryError = HTTPValidationError;

export function useGetFile<
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  fileId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFile>>,
          TError,
          Awaited<ReturnType<typeof getFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFile<
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFile>>,
          TError,
          Awaited<ReturnType<typeof getFile>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFile<
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get File
 */

export function useGetFile<
  TData = Awaited<ReturnType<typeof getFile>>,
  TError = HTTPValidationError,
>(
  storeId: string,
  fileId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getFile>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFileQueryOptions(storeId, fileId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Delete a file and all its chunks and embeddings.
 * @summary Delete File
 */
export type deleteFileResponse204 = {
  data: void;
  status: 204;
};

export type deleteFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteFileResponseSuccess = deleteFileResponse204 & {
  headers: Headers;
};
export type deleteFileResponseError = deleteFileResponse422 & {
  headers: Headers;
};

export type deleteFileResponse =
  | deleteFileResponseSuccess
  | deleteFileResponseError;

export const getDeleteFileUrl = (storeId: string, fileId: string) => {
  return `/api/v1/vector-stores/${storeId}/files/${fileId}`;
};

export const deleteFile = async (
  storeId: string,
  fileId: string,
  options?: RequestInit,
): Promise<deleteFileResponse> => {
  return customInstance<deleteFileResponse>(getDeleteFileUrl(storeId, fileId), {
    ...options,
    method: "DELETE",
  });
};

export const getDeleteFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteFile>>,
    TError,
    { storeId: string; fileId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { storeId: string; fileId: string },
  TContext
> => {
  const mutationKey = ["deleteFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteFile>>,
    { storeId: string; fileId: string }
  > = (props) => {
    const { storeId, fileId } = props ?? {};

    return deleteFile(storeId, fileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteFile>>
>;

export type DeleteFileMutationError = HTTPValidationError;

/**
 * @summary Delete File
 */
export const useDeleteFile = <TError = HTTPValidationError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteFile>>,
      TError,
      { storeId: string; fileId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteFile>>,
  TError,
  { storeId: string; fileId: string },
  TContext
> => {
  return useMutation(getDeleteFileMutationOptions(options), queryClient);
};

/**
 * Re-index a file (useful after processing failures).
 * @summary Reindex File
 */
export type reindexFileResponse200 = {
  data: FileResponse;
  status: 200;
};

export type reindexFileResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type reindexFileResponseSuccess = reindexFileResponse200 & {
  headers: Headers;
};
export type reindexFileResponseError = reindexFileResponse422 & {
  headers: Headers;
};

export type reindexFileResponse =
  | reindexFileResponseSuccess
  | reindexFileResponseError;

export const getReindexFileUrl = (storeId: string, fileId: string) => {
  return `/api/v1/vector-stores/${storeId}/files/${fileId}/reindex`;
};

export const reindexFile = async (
  storeId: string,
  fileId: string,
  options?: RequestInit,
): Promise<reindexFileResponse> => {
  return customInstance<reindexFileResponse>(
    getReindexFileUrl(storeId, fileId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getReindexFileMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof reindexFile>>,
    TError,
    { storeId: string; fileId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof reindexFile>>,
  TError,
  { storeId: string; fileId: string },
  TContext
> => {
  const mutationKey = ["reindexFile"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof reindexFile>>,
    { storeId: string; fileId: string }
  > = (props) => {
    const { storeId, fileId } = props ?? {};

    return reindexFile(storeId, fileId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ReindexFileMutationResult = NonNullable<
  Awaited<ReturnType<typeof reindexFile>>
>;

export type ReindexFileMutationError = HTTPValidationError;

/**
 * @summary Reindex File
 */
export const useReindexFile = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof reindexFile>>,
      TError,
      { storeId: string; fileId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof reindexFile>>,
  TError,
  { storeId: string; fileId: string },
  TContext
> => {
  return useMutation(getReindexFileMutationOptions(options), queryClient);
};

/**
 * Search within a single vector store.
 * @summary Search Store
 */
export type searchStoreResponse200 = {
  data: SearchResponse;
  status: 200;
};

export type searchStoreResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type searchStoreResponseSuccess = searchStoreResponse200 & {
  headers: Headers;
};
export type searchStoreResponseError = searchStoreResponse422 & {
  headers: Headers;
};

export type searchStoreResponse =
  | searchStoreResponseSuccess
  | searchStoreResponseError;

export const getSearchStoreUrl = (storeId: string) => {
  return `/api/v1/vector-stores/${storeId}/search`;
};

export const searchStore = async (
  storeId: string,
  searchRequest: SearchRequest,
  options?: RequestInit,
): Promise<searchStoreResponse> => {
  return customInstance<searchStoreResponse>(getSearchStoreUrl(storeId), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(searchRequest),
  });
};

export const getSearchStoreMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchStore>>,
    TError,
    { storeId: string; data: SearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchStore>>,
  TError,
  { storeId: string; data: SearchRequest },
  TContext
> => {
  const mutationKey = ["searchStore"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchStore>>,
    { storeId: string; data: SearchRequest }
  > = (props) => {
    const { storeId, data } = props ?? {};

    return searchStore(storeId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchStoreMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchStore>>
>;
export type SearchStoreMutationBody = SearchRequest;
export type SearchStoreMutationError = HTTPValidationError;

/**
 * @summary Search Store
 */
export const useSearchStore = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchStore>>,
      TError,
      { storeId: string; data: SearchRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchStore>>,
  TError,
  { storeId: string; data: SearchRequest },
  TContext
> => {
  return useMutation(getSearchStoreMutationOptions(options), queryClient);
};

/**
 * Search across all vector stores in the organization.
 * @summary Search All Stores
 */
export type searchAllStoresResponse200 = {
  data: SearchResponse;
  status: 200;
};

export type searchAllStoresResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type searchAllStoresResponseSuccess = searchAllStoresResponse200 & {
  headers: Headers;
};
export type searchAllStoresResponseError = searchAllStoresResponse422 & {
  headers: Headers;
};

export type searchAllStoresResponse =
  | searchAllStoresResponseSuccess
  | searchAllStoresResponseError;

export const getSearchAllStoresUrl = () => {
  return `/api/v1/vector-stores/search`;
};

export const searchAllStores = async (
  searchRequest: SearchRequest,
  options?: RequestInit,
): Promise<searchAllStoresResponse> => {
  return customInstance<searchAllStoresResponse>(getSearchAllStoresUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(searchRequest),
  });
};

export const getSearchAllStoresMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof searchAllStores>>,
    TError,
    { data: SearchRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof searchAllStores>>,
  TError,
  { data: SearchRequest },
  TContext
> => {
  const mutationKey = ["searchAllStores"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof searchAllStores>>,
    { data: SearchRequest }
  > = (props) => {
    const { data } = props ?? {};

    return searchAllStores(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SearchAllStoresMutationResult = NonNullable<
  Awaited<ReturnType<typeof searchAllStores>>
>;
export type SearchAllStoresMutationBody = SearchRequest;
export type SearchAllStoresMutationError = HTTPValidationError;

/**
 * @summary Search All Stores
 */
export const useSearchAllStores = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof searchAllStores>>,
      TError,
      { data: SearchRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof searchAllStores>>,
  TError,
  { data: SearchRequest },
  TContext
> => {
  return useMutation(getSearchAllStoresMutationOptions(options), queryClient);
};

/**
 * Connect Fireflies account by validating and storing API key.
 * @summary Connect Fireflies
 */
export type connectFirefliesResponse200 = {
  data: FirefliesStatusResponse;
  status: 200;
};

export type connectFirefliesResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type connectFirefliesResponseSuccess = connectFirefliesResponse200 & {
  headers: Headers;
};
export type connectFirefliesResponseError = connectFirefliesResponse422 & {
  headers: Headers;
};

export type connectFirefliesResponse =
  | connectFirefliesResponseSuccess
  | connectFirefliesResponseError;

export const getConnectFirefliesUrl = () => {
  return `/api/v1/integrations/fireflies/connect`;
};

export const connectFireflies = async (
  firefliesConnectRequest: FirefliesConnectRequest,
  options?: RequestInit,
): Promise<connectFirefliesResponse> => {
  return customInstance<connectFirefliesResponse>(getConnectFirefliesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(firefliesConnectRequest),
  });
};

export const getConnectFirefliesMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof connectFireflies>>,
    TError,
    { data: FirefliesConnectRequest },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof connectFireflies>>,
  TError,
  { data: FirefliesConnectRequest },
  TContext
> => {
  const mutationKey = ["connectFireflies"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof connectFireflies>>,
    { data: FirefliesConnectRequest }
  > = (props) => {
    const { data } = props ?? {};

    return connectFireflies(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConnectFirefliesMutationResult = NonNullable<
  Awaited<ReturnType<typeof connectFireflies>>
>;
export type ConnectFirefliesMutationBody = FirefliesConnectRequest;
export type ConnectFirefliesMutationError = HTTPValidationError;

/**
 * @summary Connect Fireflies
 */
export const useConnectFireflies = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof connectFireflies>>,
      TError,
      { data: FirefliesConnectRequest },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof connectFireflies>>,
  TError,
  { data: FirefliesConnectRequest },
  TContext
> => {
  return useMutation(getConnectFirefliesMutationOptions(options), queryClient);
};

/**
 * Disconnect Fireflies account by removing stored API key.
 * @summary Disconnect Fireflies
 */
export type disconnectFirefliesResponse200 = {
  data: FirefliesDisconnectResponse;
  status: 200;
};

export type disconnectFirefliesResponseSuccess =
  disconnectFirefliesResponse200 & {
    headers: Headers;
  };
export type disconnectFirefliesResponse = disconnectFirefliesResponseSuccess;

export const getDisconnectFirefliesUrl = () => {
  return `/api/v1/integrations/fireflies/disconnect`;
};

export const disconnectFireflies = async (
  options?: RequestInit,
): Promise<disconnectFirefliesResponse> => {
  return customInstance<disconnectFirefliesResponse>(
    getDisconnectFirefliesUrl(),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getDisconnectFirefliesMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof disconnectFireflies>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof disconnectFireflies>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["disconnectFireflies"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof disconnectFireflies>>,
    void
  > = () => {
    return disconnectFireflies(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DisconnectFirefliesMutationResult = NonNullable<
  Awaited<ReturnType<typeof disconnectFireflies>>
>;

export type DisconnectFirefliesMutationError = unknown;

/**
 * @summary Disconnect Fireflies
 */
export const useDisconnectFireflies = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof disconnectFireflies>>,
      TError,
      void,
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof disconnectFireflies>>,
  TError,
  void,
  TContext
> => {
  return useMutation(
    getDisconnectFirefliesMutationOptions(options),
    queryClient,
  );
};

/**
 * Get current Fireflies connection status.
 * @summary Get Fireflies Status
 */
export type getFirefliesStatusResponse200 = {
  data: FirefliesStatusResponse;
  status: 200;
};

export type getFirefliesStatusResponseSuccess =
  getFirefliesStatusResponse200 & {
    headers: Headers;
  };
export type getFirefliesStatusResponse = getFirefliesStatusResponseSuccess;

export const getGetFirefliesStatusUrl = () => {
  return `/api/v1/integrations/fireflies/status`;
};

export const getFirefliesStatus = async (
  options?: RequestInit,
): Promise<getFirefliesStatusResponse> => {
  return customInstance<getFirefliesStatusResponse>(
    getGetFirefliesStatusUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetFirefliesStatusQueryKey = () => {
  return [`/api/v1/integrations/fireflies/status`] as const;
};

export const getGetFirefliesStatusQueryOptions = <
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getFirefliesStatus>>,
      TError,
      TData
    >
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetFirefliesStatusQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getFirefliesStatus>>
  > = ({ signal }) => getFirefliesStatus({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getFirefliesStatus>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetFirefliesStatusQueryResult = NonNullable<
  Awaited<ReturnType<typeof getFirefliesStatus>>
>;
export type GetFirefliesStatusQueryError = unknown;

export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFirefliesStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirefliesStatus>>,
          TError,
          Awaited<ReturnType<typeof getFirefliesStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFirefliesStatus>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFirefliesStatus>>,
          TError,
          Awaited<ReturnType<typeof getFirefliesStatus>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFirefliesStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Fireflies Status
 */

export function useGetFirefliesStatus<
  TData = Awaited<ReturnType<typeof getFirefliesStatus>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getFirefliesStatus>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetFirefliesStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List transcripts from Fireflies API.
 * @summary List Fireflies Transcripts
 */
export type listFirefliesTranscriptsResponse200 = {
  data: FirefliesTranscriptListResponse;
  status: 200;
};

export type listFirefliesTranscriptsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listFirefliesTranscriptsResponseSuccess =
  listFirefliesTranscriptsResponse200 & {
    headers: Headers;
  };
export type listFirefliesTranscriptsResponseError =
  listFirefliesTranscriptsResponse422 & {
    headers: Headers;
  };

export type listFirefliesTranscriptsResponse =
  | listFirefliesTranscriptsResponseSuccess
  | listFirefliesTranscriptsResponseError;

export const getListFirefliesTranscriptsUrl = (
  params?: ListFirefliesTranscriptsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/integrations/fireflies/transcripts?${stringifiedParams}`
    : `/api/v1/integrations/fireflies/transcripts`;
};

export const listFirefliesTranscripts = async (
  params?: ListFirefliesTranscriptsParams,
  options?: RequestInit,
): Promise<listFirefliesTranscriptsResponse> => {
  return customInstance<listFirefliesTranscriptsResponse>(
    getListFirefliesTranscriptsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListFirefliesTranscriptsQueryKey = (
  params?: ListFirefliesTranscriptsParams,
) => {
  return [
    `/api/v1/integrations/fireflies/transcripts`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListFirefliesTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFirefliesTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListFirefliesTranscriptsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listFirefliesTranscripts>>
  > = ({ signal }) =>
    listFirefliesTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listFirefliesTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListFirefliesTranscriptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listFirefliesTranscripts>>
>;
export type ListFirefliesTranscriptsQueryError = HTTPValidationError;

export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListFirefliesTranscriptsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFirefliesTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFirefliesTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFirefliesTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Fireflies Transcripts
 */

export function useListFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof listFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listFirefliesTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListFirefliesTranscriptsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Search transcripts via Fireflies API.
 * @summary Search Fireflies Transcripts
 */
export type searchFirefliesTranscriptsResponse200 = {
  data: FirefliesTranscriptListResponse;
  status: 200;
};

export type searchFirefliesTranscriptsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type searchFirefliesTranscriptsResponseSuccess =
  searchFirefliesTranscriptsResponse200 & {
    headers: Headers;
  };
export type searchFirefliesTranscriptsResponseError =
  searchFirefliesTranscriptsResponse422 & {
    headers: Headers;
  };

export type searchFirefliesTranscriptsResponse =
  | searchFirefliesTranscriptsResponseSuccess
  | searchFirefliesTranscriptsResponseError;

export const getSearchFirefliesTranscriptsUrl = (
  params: SearchFirefliesTranscriptsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/integrations/fireflies/transcripts/search?${stringifiedParams}`
    : `/api/v1/integrations/fireflies/transcripts/search`;
};

export const searchFirefliesTranscripts = async (
  params: SearchFirefliesTranscriptsParams,
  options?: RequestInit,
): Promise<searchFirefliesTranscriptsResponse> => {
  return customInstance<searchFirefliesTranscriptsResponse>(
    getSearchFirefliesTranscriptsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getSearchFirefliesTranscriptsQueryKey = (
  params?: SearchFirefliesTranscriptsParams,
) => {
  return [
    `/api/v1/integrations/fireflies/transcripts/search`,
    ...(params ? [params] : []),
  ] as const;
};

export const getSearchFirefliesTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getSearchFirefliesTranscriptsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof searchFirefliesTranscripts>>
  > = ({ signal }) =>
    searchFirefliesTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SearchFirefliesTranscriptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof searchFirefliesTranscripts>>
>;
export type SearchFirefliesTranscriptsQueryError = HTTPValidationError;

export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
          TError,
          Awaited<ReturnType<typeof searchFirefliesTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Search Fireflies Transcripts
 */

export function useSearchFirefliesTranscripts<
  TData = Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
  TError = HTTPValidationError,
>(
  params: SearchFirefliesTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof searchFirefliesTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getSearchFirefliesTranscriptsQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Import a transcript from Fireflies to local storage.
 * @summary Import Fireflies Transcript
 */
export type importFirefliesTranscriptResponse200 = {
  data: ImportTranscriptResponse;
  status: 200;
};

export type importFirefliesTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type importFirefliesTranscriptResponseSuccess =
  importFirefliesTranscriptResponse200 & {
    headers: Headers;
  };
export type importFirefliesTranscriptResponseError =
  importFirefliesTranscriptResponse422 & {
    headers: Headers;
  };

export type importFirefliesTranscriptResponse =
  | importFirefliesTranscriptResponseSuccess
  | importFirefliesTranscriptResponseError;

export const getImportFirefliesTranscriptUrl = (transcriptId: string) => {
  return `/api/v1/integrations/fireflies/transcripts/${transcriptId}/import`;
};

export const importFirefliesTranscript = async (
  transcriptId: string,
  options?: RequestInit,
): Promise<importFirefliesTranscriptResponse> => {
  return customInstance<importFirefliesTranscriptResponse>(
    getImportFirefliesTranscriptUrl(transcriptId),
    {
      ...options,
      method: "POST",
    },
  );
};

export const getImportFirefliesTranscriptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof importFirefliesTranscript>>,
    TError,
    { transcriptId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof importFirefliesTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  const mutationKey = ["importFirefliesTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof importFirefliesTranscript>>,
    { transcriptId: string }
  > = (props) => {
    const { transcriptId } = props ?? {};

    return importFirefliesTranscript(transcriptId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ImportFirefliesTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof importFirefliesTranscript>>
>;

export type ImportFirefliesTranscriptMutationError = HTTPValidationError;

/**
 * @summary Import Fireflies Transcript
 */
export const useImportFirefliesTranscript = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof importFirefliesTranscript>>,
      TError,
      { transcriptId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof importFirefliesTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  return useMutation(
    getImportFirefliesTranscriptMutationOptions(options),
    queryClient,
  );
};

/**
 * List imported transcripts for the current user.
 * @summary List Imported Transcripts
 */
export type listImportedTranscriptsResponse200 = {
  data: TranscriptListResponse;
  status: 200;
};

export type listImportedTranscriptsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listImportedTranscriptsResponseSuccess =
  listImportedTranscriptsResponse200 & {
    headers: Headers;
  };
export type listImportedTranscriptsResponseError =
  listImportedTranscriptsResponse422 & {
    headers: Headers;
  };

export type listImportedTranscriptsResponse =
  | listImportedTranscriptsResponseSuccess
  | listImportedTranscriptsResponseError;

export const getListImportedTranscriptsUrl = (
  params?: ListImportedTranscriptsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/integrations/fireflies/imported?${stringifiedParams}`
    : `/api/v1/integrations/fireflies/imported`;
};

export const listImportedTranscripts = async (
  params?: ListImportedTranscriptsParams,
  options?: RequestInit,
): Promise<listImportedTranscriptsResponse> => {
  return customInstance<listImportedTranscriptsResponse>(
    getListImportedTranscriptsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListImportedTranscriptsQueryKey = (
  params?: ListImportedTranscriptsParams,
) => {
  return [
    `/api/v1/integrations/fireflies/imported`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListImportedTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listImportedTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListImportedTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listImportedTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListImportedTranscriptsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listImportedTranscripts>>
  > = ({ signal }) =>
    listImportedTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listImportedTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListImportedTranscriptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listImportedTranscripts>>
>;
export type ListImportedTranscriptsQueryError = HTTPValidationError;

export function useListImportedTranscripts<
  TData = Awaited<ReturnType<typeof listImportedTranscripts>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListImportedTranscriptsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listImportedTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImportedTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listImportedTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListImportedTranscripts<
  TData = Awaited<ReturnType<typeof listImportedTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListImportedTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listImportedTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listImportedTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listImportedTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListImportedTranscripts<
  TData = Awaited<ReturnType<typeof listImportedTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListImportedTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listImportedTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Imported Transcripts
 */

export function useListImportedTranscripts<
  TData = Awaited<ReturnType<typeof listImportedTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListImportedTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listImportedTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListImportedTranscriptsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Delete an imported transcript.
 * @summary Delete Imported Transcript
 */
export type deleteImportedTranscriptResponse200 = {
  data: DeleteTranscriptResponse;
  status: 200;
};

export type deleteImportedTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteImportedTranscriptResponseSuccess =
  deleteImportedTranscriptResponse200 & {
    headers: Headers;
  };
export type deleteImportedTranscriptResponseError =
  deleteImportedTranscriptResponse422 & {
    headers: Headers;
  };

export type deleteImportedTranscriptResponse =
  | deleteImportedTranscriptResponseSuccess
  | deleteImportedTranscriptResponseError;

export const getDeleteImportedTranscriptUrl = (transcriptId: string) => {
  return `/api/v1/integrations/fireflies/imported/${transcriptId}`;
};

export const deleteImportedTranscript = async (
  transcriptId: string,
  options?: RequestInit,
): Promise<deleteImportedTranscriptResponse> => {
  return customInstance<deleteImportedTranscriptResponse>(
    getDeleteImportedTranscriptUrl(transcriptId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteImportedTranscriptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteImportedTranscript>>,
    TError,
    { transcriptId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteImportedTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  const mutationKey = ["deleteImportedTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteImportedTranscript>>,
    { transcriptId: string }
  > = (props) => {
    const { transcriptId } = props ?? {};

    return deleteImportedTranscript(transcriptId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteImportedTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteImportedTranscript>>
>;

export type DeleteImportedTranscriptMutationError = HTTPValidationError;

/**
 * @summary Delete Imported Transcript
 */
export const useDeleteImportedTranscript = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteImportedTranscript>>,
      TError,
      { transcriptId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteImportedTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  return useMutation(
    getDeleteImportedTranscriptMutationOptions(options),
    queryClient,
  );
};

/**
 * List audit logs for the user's organization. Requires sales_manager role.
 * @summary List Org Audit Logs
 */
export type listOrgAuditLogsResponse200 = {
  data: AuditLogListResponse;
  status: 200;
};

export type listOrgAuditLogsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listOrgAuditLogsResponseSuccess = listOrgAuditLogsResponse200 & {
  headers: Headers;
};
export type listOrgAuditLogsResponseError = listOrgAuditLogsResponse422 & {
  headers: Headers;
};

export type listOrgAuditLogsResponse =
  | listOrgAuditLogsResponseSuccess
  | listOrgAuditLogsResponseError;

export const getListOrgAuditLogsUrl = (params?: ListOrgAuditLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/audit-logs?${stringifiedParams}`
    : `/api/v1/audit-logs`;
};

export const listOrgAuditLogs = async (
  params?: ListOrgAuditLogsParams,
  options?: RequestInit,
): Promise<listOrgAuditLogsResponse> => {
  return customInstance<listOrgAuditLogsResponse>(
    getListOrgAuditLogsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListOrgAuditLogsQueryKey = (
  params?: ListOrgAuditLogsParams,
) => {
  return [`/api/v1/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getListOrgAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrgAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListOrgAuditLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listOrgAuditLogs>>
  > = ({ signal }) => listOrgAuditLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listOrgAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListOrgAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listOrgAuditLogs>>
>;
export type ListOrgAuditLogsQueryError = HTTPValidationError;

export function useListOrgAuditLogs<
  TData = Awaited<ReturnType<typeof listOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListOrgAuditLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrgAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listOrgAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrgAuditLogs<
  TData = Awaited<ReturnType<typeof listOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrgAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listOrgAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listOrgAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListOrgAuditLogs<
  TData = Awaited<ReturnType<typeof listOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrgAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Org Audit Logs
 */

export function useListOrgAuditLogs<
  TData = Awaited<ReturnType<typeof listOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listOrgAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListOrgAuditLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Export org audit logs as CSV. Requires sales_manager role.
 * @summary Export Org Audit Logs
 */
export type exportOrgAuditLogsResponse200 = {
  data: unknown;
  status: 200;
};

export type exportOrgAuditLogsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type exportOrgAuditLogsResponseSuccess =
  exportOrgAuditLogsResponse200 & {
    headers: Headers;
  };
export type exportOrgAuditLogsResponseError = exportOrgAuditLogsResponse422 & {
  headers: Headers;
};

export type exportOrgAuditLogsResponse =
  | exportOrgAuditLogsResponseSuccess
  | exportOrgAuditLogsResponseError;

export const getExportOrgAuditLogsUrl = (params?: ExportOrgAuditLogsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/audit-logs/export?${stringifiedParams}`
    : `/api/v1/audit-logs/export`;
};

export const exportOrgAuditLogs = async (
  params?: ExportOrgAuditLogsParams,
  options?: RequestInit,
): Promise<exportOrgAuditLogsResponse> => {
  return customInstance<exportOrgAuditLogsResponse>(
    getExportOrgAuditLogsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getExportOrgAuditLogsQueryKey = (
  params?: ExportOrgAuditLogsParams,
) => {
  return [`/api/v1/audit-logs/export`, ...(params ? [params] : [])] as const;
};

export const getExportOrgAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportOrgAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportOrgAuditLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportOrgAuditLogs>>
  > = ({ signal }) => exportOrgAuditLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportOrgAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportOrgAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportOrgAuditLogs>>
>;
export type ExportOrgAuditLogsQueryError = HTTPValidationError;

export function useExportOrgAuditLogs<
  TData = Awaited<ReturnType<typeof exportOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params: undefined | ExportOrgAuditLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportOrgAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrgAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof exportOrgAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportOrgAuditLogs<
  TData = Awaited<ReturnType<typeof exportOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportOrgAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportOrgAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof exportOrgAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportOrgAuditLogs<
  TData = Awaited<ReturnType<typeof exportOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportOrgAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export Org Audit Logs
 */

export function useExportOrgAuditLogs<
  TData = Awaited<ReturnType<typeof exportOrgAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportOrgAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportOrgAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportOrgAuditLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * List system-wide audit logs. Super admin only.
 * @summary List System Audit Logs
 */
export type listSystemAuditLogsResponse200 = {
  data: AuditLogListResponse;
  status: 200;
};

export type listSystemAuditLogsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listSystemAuditLogsResponseSuccess =
  listSystemAuditLogsResponse200 & {
    headers: Headers;
  };
export type listSystemAuditLogsResponseError =
  listSystemAuditLogsResponse422 & {
    headers: Headers;
  };

export type listSystemAuditLogsResponse =
  | listSystemAuditLogsResponseSuccess
  | listSystemAuditLogsResponseError;

export const getListSystemAuditLogsUrl = (
  params?: ListSystemAuditLogsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/audit-logs?${stringifiedParams}`
    : `/api/v1/admin/audit-logs`;
};

export const listSystemAuditLogs = async (
  params?: ListSystemAuditLogsParams,
  options?: RequestInit,
): Promise<listSystemAuditLogsResponse> => {
  return customInstance<listSystemAuditLogsResponse>(
    getListSystemAuditLogsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListSystemAuditLogsQueryKey = (
  params?: ListSystemAuditLogsParams,
) => {
  return [`/api/v1/admin/audit-logs`, ...(params ? [params] : [])] as const;
};

export const getListSystemAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof listSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSystemAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getListSystemAuditLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listSystemAuditLogs>>
  > = ({ signal }) =>
    listSystemAuditLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listSystemAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListSystemAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listSystemAuditLogs>>
>;
export type ListSystemAuditLogsQueryError = HTTPValidationError;

export function useListSystemAuditLogs<
  TData = Awaited<ReturnType<typeof listSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListSystemAuditLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSystemAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSystemAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listSystemAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSystemAuditLogs<
  TData = Awaited<ReturnType<typeof listSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSystemAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listSystemAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof listSystemAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListSystemAuditLogs<
  TData = Awaited<ReturnType<typeof listSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSystemAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List System Audit Logs
 */

export function useListSystemAuditLogs<
  TData = Awaited<ReturnType<typeof listSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ListSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listSystemAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListSystemAuditLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Export system-wide audit logs as CSV. Super admin only.
 * @summary Export System Audit Logs
 */
export type exportSystemAuditLogsResponse200 = {
  data: unknown;
  status: 200;
};

export type exportSystemAuditLogsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type exportSystemAuditLogsResponseSuccess =
  exportSystemAuditLogsResponse200 & {
    headers: Headers;
  };
export type exportSystemAuditLogsResponseError =
  exportSystemAuditLogsResponse422 & {
    headers: Headers;
  };

export type exportSystemAuditLogsResponse =
  | exportSystemAuditLogsResponseSuccess
  | exportSystemAuditLogsResponseError;

export const getExportSystemAuditLogsUrl = (
  params?: ExportSystemAuditLogsParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/admin/audit-logs/export?${stringifiedParams}`
    : `/api/v1/admin/audit-logs/export`;
};

export const exportSystemAuditLogs = async (
  params?: ExportSystemAuditLogsParams,
  options?: RequestInit,
): Promise<exportSystemAuditLogsResponse> => {
  return customInstance<exportSystemAuditLogsResponse>(
    getExportSystemAuditLogsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getExportSystemAuditLogsQueryKey = (
  params?: ExportSystemAuditLogsParams,
) => {
  return [
    `/api/v1/admin/audit-logs/export`,
    ...(params ? [params] : []),
  ] as const;
};

export const getExportSystemAuditLogsQueryOptions = <
  TData = Awaited<ReturnType<typeof exportSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportSystemAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getExportSystemAuditLogsQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof exportSystemAuditLogs>>
  > = ({ signal }) =>
    exportSystemAuditLogs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof exportSystemAuditLogs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ExportSystemAuditLogsQueryResult = NonNullable<
  Awaited<ReturnType<typeof exportSystemAuditLogs>>
>;
export type ExportSystemAuditLogsQueryError = HTTPValidationError;

export function useExportSystemAuditLogs<
  TData = Awaited<ReturnType<typeof exportSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params: undefined | ExportSystemAuditLogsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportSystemAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSystemAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof exportSystemAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportSystemAuditLogs<
  TData = Awaited<ReturnType<typeof exportSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportSystemAuditLogs>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof exportSystemAuditLogs>>,
          TError,
          Awaited<ReturnType<typeof exportSystemAuditLogs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useExportSystemAuditLogs<
  TData = Awaited<ReturnType<typeof exportSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportSystemAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Export System Audit Logs
 */

export function useExportSystemAuditLogs<
  TData = Awaited<ReturnType<typeof exportSystemAuditLogs>>,
  TError = HTTPValidationError,
>(
  params?: ExportSystemAuditLogsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof exportSystemAuditLogs>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getExportSystemAuditLogsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get dashboard summary metrics for the current period.
 * @summary Get Summary
 */
export type getSummaryResponse200 = {
  data: DashboardSummary;
  status: 200;
};

export type getSummaryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getSummaryResponseSuccess = getSummaryResponse200 & {
  headers: Headers;
};
export type getSummaryResponseError = getSummaryResponse422 & {
  headers: Headers;
};

export type getSummaryResponse =
  | getSummaryResponseSuccess
  | getSummaryResponseError;

export const getGetSummaryUrl = (params?: GetSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/metrics/summary?${stringifiedParams}`
    : `/api/v1/metrics/summary`;
};

export const getSummary = async (
  params?: GetSummaryParams,
  options?: RequestInit,
): Promise<getSummaryResponse> => {
  return customInstance<getSummaryResponse>(getGetSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetSummaryQueryKey = (params?: GetSummaryParams) => {
  return [`/api/v1/metrics/summary`, ...(params ? [params] : [])] as const;
};

export const getGetSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSummary>>> = ({
    signal,
  }) => getSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSummary>>
>;
export type GetSummaryQueryError = HTTPValidationError;

export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummary>>,
          TError,
          Awaited<ReturnType<typeof getSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSummary>>,
          TError,
          Awaited<ReturnType<typeof getSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Summary
 */

export function useGetSummary<
  TData = Awaited<ReturnType<typeof getSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get usage data points over a date range.
 * @summary Get Usage
 */
export type getUsageResponse200 = {
  data: UsageOverTime;
  status: 200;
};

export type getUsageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getUsageResponseSuccess = getUsageResponse200 & {
  headers: Headers;
};
export type getUsageResponseError = getUsageResponse422 & {
  headers: Headers;
};

export type getUsageResponse = getUsageResponseSuccess | getUsageResponseError;

export const getGetUsageUrl = (params?: GetUsageParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/metrics/usage?${stringifiedParams}`
    : `/api/v1/metrics/usage`;
};

export const getUsage = async (
  params?: GetUsageParams,
  options?: RequestInit,
): Promise<getUsageResponse> => {
  return customInstance<getUsageResponse>(getGetUsageUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetUsageQueryKey = (params?: GetUsageParams) => {
  return [`/api/v1/metrics/usage`, ...(params ? [params] : [])] as const;
};

export const getGetUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsage>>> = ({
    signal,
  }) => getUsage(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUsage>>
>;
export type GetUsageQueryError = HTTPValidationError;

export function useGetUsage<
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsage>>,
          TError,
          Awaited<ReturnType<typeof getUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsage<
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsage>>,
          TError,
          Awaited<ReturnType<typeof getUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUsage<
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Usage
 */

export function useGetUsage<
  TData = Awaited<ReturnType<typeof getUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUsageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get score analytics with aggregates and trend.
 * @summary Get Scores
 */
export type getScoresResponse200 = {
  data: ScoreAnalytics;
  status: 200;
};

export type getScoresResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getScoresResponseSuccess = getScoresResponse200 & {
  headers: Headers;
};
export type getScoresResponseError = getScoresResponse422 & {
  headers: Headers;
};

export type getScoresResponse =
  | getScoresResponseSuccess
  | getScoresResponseError;

export const getGetScoresUrl = (params?: GetScoresParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/metrics/scores?${stringifiedParams}`
    : `/api/v1/metrics/scores`;
};

export const getScores = async (
  params?: GetScoresParams,
  options?: RequestInit,
): Promise<getScoresResponse> => {
  return customInstance<getScoresResponse>(getGetScoresUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetScoresQueryKey = (params?: GetScoresParams) => {
  return [`/api/v1/metrics/scores`, ...(params ? [params] : [])] as const;
};

export const getGetScoresQueryOptions = <
  TData = Awaited<ReturnType<typeof getScores>>,
  TError = HTTPValidationError,
>(
  params?: GetScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getScores>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetScoresQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getScores>>> = ({
    signal,
  }) => getScores(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getScores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetScoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getScores>>
>;
export type GetScoresQueryError = HTTPValidationError;

export function useGetScores<
  TData = Awaited<ReturnType<typeof getScores>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetScoresParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getScores>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScores>>,
          TError,
          Awaited<ReturnType<typeof getScores>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScores<
  TData = Awaited<ReturnType<typeof getScores>>,
  TError = HTTPValidationError,
>(
  params?: GetScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getScores>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getScores>>,
          TError,
          Awaited<ReturnType<typeof getScores>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetScores<
  TData = Awaited<ReturnType<typeof getScores>>,
  TError = HTTPValidationError,
>(
  params?: GetScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getScores>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Scores
 */

export function useGetScores<
  TData = Awaited<ReturnType<typeof getScores>>,
  TError = HTTPValidationError,
>(
  params?: GetScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getScores>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetScoresQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get per-user metrics. Requires sales_manager role or higher.
 * @summary Get User Metrics
 */
export type getUserMetricsResponse200 = {
  data: UserMetricsResponse;
  status: 200;
};

export type getUserMetricsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getUserMetricsResponseSuccess = getUserMetricsResponse200 & {
  headers: Headers;
};
export type getUserMetricsResponseError = getUserMetricsResponse422 & {
  headers: Headers;
};

export type getUserMetricsResponse =
  | getUserMetricsResponseSuccess
  | getUserMetricsResponseError;

export const getGetUserMetricsUrl = (params?: GetUserMetricsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/metrics/users?${stringifiedParams}`
    : `/api/v1/metrics/users`;
};

export const getUserMetrics = async (
  params?: GetUserMetricsParams,
  options?: RequestInit,
): Promise<getUserMetricsResponse> => {
  return customInstance<getUserMetricsResponse>(getGetUserMetricsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetUserMetricsQueryKey = (params?: GetUserMetricsParams) => {
  return [`/api/v1/metrics/users`, ...(params ? [params] : [])] as const;
};

export const getGetUserMetricsQueryOptions = <
  TData = Awaited<ReturnType<typeof getUserMetrics>>,
  TError = HTTPValidationError,
>(
  params?: GetUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetUserMetricsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserMetrics>>> = ({
    signal,
  }) => getUserMetrics(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getUserMetrics>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetUserMetricsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getUserMetrics>>
>;
export type GetUserMetricsQueryError = HTTPValidationError;

export function useGetUserMetrics<
  TData = Awaited<ReturnType<typeof getUserMetrics>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetUserMetricsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMetrics>>,
          TError,
          Awaited<ReturnType<typeof getUserMetrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserMetrics<
  TData = Awaited<ReturnType<typeof getUserMetrics>>,
  TError = HTTPValidationError,
>(
  params?: GetUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserMetrics>>,
          TError,
          Awaited<ReturnType<typeof getUserMetrics>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetUserMetrics<
  TData = Awaited<ReturnType<typeof getUserMetrics>>,
  TError = HTTPValidationError,
>(
  params?: GetUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get User Metrics
 */

export function useGetUserMetrics<
  TData = Awaited<ReturnType<typeof getUserMetrics>>,
  TError = HTTPValidationError,
>(
  params?: GetUserMetricsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getUserMetrics>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetUserMetricsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get LLM usage breakdown. Requires sales_manager role or higher.
 * @summary Get Llm Usage
 */
export type getLlmUsageResponse200 = {
  data: LlmUsageBreakdown;
  status: 200;
};

export type getLlmUsageResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getLlmUsageResponseSuccess = getLlmUsageResponse200 & {
  headers: Headers;
};
export type getLlmUsageResponseError = getLlmUsageResponse422 & {
  headers: Headers;
};

export type getLlmUsageResponse =
  | getLlmUsageResponseSuccess
  | getLlmUsageResponseError;

export const getGetLlmUsageUrl = (params?: GetLlmUsageParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/metrics/llm?${stringifiedParams}`
    : `/api/v1/metrics/llm`;
};

export const getLlmUsage = async (
  params?: GetLlmUsageParams,
  options?: RequestInit,
): Promise<getLlmUsageResponse> => {
  return customInstance<getLlmUsageResponse>(getGetLlmUsageUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetLlmUsageQueryKey = (params?: GetLlmUsageParams) => {
  return [`/api/v1/metrics/llm`, ...(params ? [params] : [])] as const;
};

export const getGetLlmUsageQueryOptions = <
  TData = Awaited<ReturnType<typeof getLlmUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetLlmUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLlmUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetLlmUsageQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getLlmUsage>>> = ({
    signal,
  }) => getLlmUsage(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getLlmUsage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetLlmUsageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getLlmUsage>>
>;
export type GetLlmUsageQueryError = HTTPValidationError;

export function useGetLlmUsage<
  TData = Awaited<ReturnType<typeof getLlmUsage>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetLlmUsageParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLlmUsage>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLlmUsage>>,
          TError,
          Awaited<ReturnType<typeof getLlmUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLlmUsage<
  TData = Awaited<ReturnType<typeof getLlmUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetLlmUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLlmUsage>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLlmUsage>>,
          TError,
          Awaited<ReturnType<typeof getLlmUsage>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetLlmUsage<
  TData = Awaited<ReturnType<typeof getLlmUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetLlmUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLlmUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Llm Usage
 */

export function useGetLlmUsage<
  TData = Awaited<ReturnType<typeof getLlmUsage>>,
  TError = HTTPValidationError,
>(
  params?: GetLlmUsageParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getLlmUsage>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetLlmUsageQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a transcript from pasted text.
 * @summary Create Transcript
 */
export type createTranscriptResponse201 = {
  data: UserTranscriptDetail;
  status: 201;
};

export type createTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type createTranscriptResponseSuccess = createTranscriptResponse201 & {
  headers: Headers;
};
export type createTranscriptResponseError = createTranscriptResponse422 & {
  headers: Headers;
};

export type createTranscriptResponse =
  | createTranscriptResponseSuccess
  | createTranscriptResponseError;

export const getCreateTranscriptUrl = () => {
  return `/api/v1/transcripts`;
};

export const createTranscript = async (
  userTranscriptCreate: UserTranscriptCreate,
  options?: RequestInit,
): Promise<createTranscriptResponse> => {
  return customInstance<createTranscriptResponse>(getCreateTranscriptUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(userTranscriptCreate),
  });
};

export const getCreateTranscriptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTranscript>>,
    TError,
    { data: UserTranscriptCreate },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTranscript>>,
  TError,
  { data: UserTranscriptCreate },
  TContext
> => {
  const mutationKey = ["createTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTranscript>>,
    { data: UserTranscriptCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createTranscript(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTranscript>>
>;
export type CreateTranscriptMutationBody = UserTranscriptCreate;
export type CreateTranscriptMutationError = HTTPValidationError;

/**
 * @summary Create Transcript
 */
export const useCreateTranscript = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTranscript>>,
      TError,
      { data: UserTranscriptCreate },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createTranscript>>,
  TError,
  { data: UserTranscriptCreate },
  TContext
> => {
  return useMutation(getCreateTranscriptMutationOptions(options), queryClient);
};

/**
 * List all transcripts (Fireflies + paste + upload) for the current user.
 * @summary List Transcripts
 */
export type listTranscriptsResponse200 = {
  data: UserTranscriptListResponse;
  status: 200;
};

export type listTranscriptsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type listTranscriptsResponseSuccess = listTranscriptsResponse200 & {
  headers: Headers;
};
export type listTranscriptsResponseError = listTranscriptsResponse422 & {
  headers: Headers;
};

export type listTranscriptsResponse =
  | listTranscriptsResponseSuccess
  | listTranscriptsResponseError;

export const getListTranscriptsUrl = (params?: ListTranscriptsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/transcripts?${stringifiedParams}`
    : `/api/v1/transcripts`;
};

export const listTranscripts = async (
  params?: ListTranscriptsParams,
  options?: RequestInit,
): Promise<listTranscriptsResponse> => {
  return customInstance<listTranscriptsResponse>(
    getListTranscriptsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getListTranscriptsQueryKey = (params?: ListTranscriptsParams) => {
  return [`/api/v1/transcripts`, ...(params ? [params] : [])] as const;
};

export const getListTranscriptsQueryOptions = <
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListTranscriptsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listTranscripts>>> = ({
    signal,
  }) => listTranscripts(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listTranscripts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListTranscriptsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listTranscripts>>
>;
export type ListTranscriptsQueryError = HTTPValidationError;

export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = HTTPValidationError,
>(
  params: undefined | ListTranscriptsParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTranscripts>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listTranscripts>>,
          TError,
          Awaited<ReturnType<typeof listTranscripts>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List Transcripts
 */

export function useListTranscripts<
  TData = Awaited<ReturnType<typeof listTranscripts>>,
  TError = HTTPValidationError,
>(
  params?: ListTranscriptsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listTranscripts>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListTranscriptsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Create a transcript from file upload (PDF, DOCX, TXT, MD, CSV).
 * @summary Upload And Create Transcript
 */
export type uploadAndCreateTranscriptResponse201 = {
  data: UserTranscriptDetail;
  status: 201;
};

export type uploadAndCreateTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type uploadAndCreateTranscriptResponseSuccess =
  uploadAndCreateTranscriptResponse201 & {
    headers: Headers;
  };
export type uploadAndCreateTranscriptResponseError =
  uploadAndCreateTranscriptResponse422 & {
    headers: Headers;
  };

export type uploadAndCreateTranscriptResponse =
  | uploadAndCreateTranscriptResponseSuccess
  | uploadAndCreateTranscriptResponseError;

export const getUploadAndCreateTranscriptUrl = (
  params?: UploadAndCreateTranscriptParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/transcripts/upload?${stringifiedParams}`
    : `/api/v1/transcripts/upload`;
};

export const uploadAndCreateTranscript = async (
  bodyUploadAndCreateTranscript: BodyUploadAndCreateTranscript,
  params?: UploadAndCreateTranscriptParams,
  options?: RequestInit,
): Promise<uploadAndCreateTranscriptResponse> => {
  const formData = new FormData();
  formData.append(`file`, bodyUploadAndCreateTranscript.file);

  return customInstance<uploadAndCreateTranscriptResponse>(
    getUploadAndCreateTranscriptUrl(params),
    {
      ...options,
      method: "POST",
      body: formData,
    },
  );
};

export const getUploadAndCreateTranscriptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadAndCreateTranscript>>,
    TError,
    {
      data: BodyUploadAndCreateTranscript;
      params?: UploadAndCreateTranscriptParams;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadAndCreateTranscript>>,
  TError,
  {
    data: BodyUploadAndCreateTranscript;
    params?: UploadAndCreateTranscriptParams;
  },
  TContext
> => {
  const mutationKey = ["uploadAndCreateTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadAndCreateTranscript>>,
    {
      data: BodyUploadAndCreateTranscript;
      params?: UploadAndCreateTranscriptParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return uploadAndCreateTranscript(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadAndCreateTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadAndCreateTranscript>>
>;
export type UploadAndCreateTranscriptMutationBody =
  BodyUploadAndCreateTranscript;
export type UploadAndCreateTranscriptMutationError = HTTPValidationError;

/**
 * @summary Upload And Create Transcript
 */
export const useUploadAndCreateTranscript = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof uploadAndCreateTranscript>>,
      TError,
      {
        data: BodyUploadAndCreateTranscript;
        params?: UploadAndCreateTranscriptParams;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof uploadAndCreateTranscript>>,
  TError,
  {
    data: BodyUploadAndCreateTranscript;
    params?: UploadAndCreateTranscriptParams;
  },
  TContext
> => {
  return useMutation(
    getUploadAndCreateTranscriptMutationOptions(options),
    queryClient,
  );
};

/**
 * Get a transcript by ID.
 * @summary Get Transcript
 */
export type getTranscriptResponse200 = {
  data: UserTranscriptDetail;
  status: 200;
};

export type getTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getTranscriptResponseSuccess = getTranscriptResponse200 & {
  headers: Headers;
};
export type getTranscriptResponseError = getTranscriptResponse422 & {
  headers: Headers;
};

export type getTranscriptResponse =
  | getTranscriptResponseSuccess
  | getTranscriptResponseError;

export const getGetTranscriptUrl = (transcriptId: string) => {
  return `/api/v1/transcripts/${transcriptId}`;
};

export const getTranscript = async (
  transcriptId: string,
  options?: RequestInit,
): Promise<getTranscriptResponse> => {
  return customInstance<getTranscriptResponse>(
    getGetTranscriptUrl(transcriptId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetTranscriptQueryKey = (transcriptId: string) => {
  return [`/api/v1/transcripts/${transcriptId}`] as const;
};

export const getGetTranscriptQueryOptions = <
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTranscriptQueryKey(transcriptId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranscript>>> = ({
    signal,
  }) => getTranscript(transcriptId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!transcriptId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTranscript>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTranscriptQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTranscript>>
>;
export type GetTranscriptQueryError = HTTPValidationError;

export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = HTTPValidationError,
>(
  transcriptId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranscript>>,
          TError,
          Awaited<ReturnType<typeof getTranscript>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTranscript>>,
          TError,
          Awaited<ReturnType<typeof getTranscript>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Transcript
 */

export function useGetTranscript<
  TData = Awaited<ReturnType<typeof getTranscript>>,
  TError = HTTPValidationError,
>(
  transcriptId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTranscript>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTranscriptQueryOptions(transcriptId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Delete a transcript.
 * @summary Delete Transcript
 */
export type deleteTranscriptResponse200 = {
  data: DeleteTranscriptResponse;
  status: 200;
};

export type deleteTranscriptResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type deleteTranscriptResponseSuccess = deleteTranscriptResponse200 & {
  headers: Headers;
};
export type deleteTranscriptResponseError = deleteTranscriptResponse422 & {
  headers: Headers;
};

export type deleteTranscriptResponse =
  | deleteTranscriptResponseSuccess
  | deleteTranscriptResponseError;

export const getDeleteTranscriptUrl = (transcriptId: string) => {
  return `/api/v1/transcripts/${transcriptId}`;
};

export const deleteTranscript = async (
  transcriptId: string,
  options?: RequestInit,
): Promise<deleteTranscriptResponse> => {
  return customInstance<deleteTranscriptResponse>(
    getDeleteTranscriptUrl(transcriptId),
    {
      ...options,
      method: "DELETE",
    },
  );
};

export const getDeleteTranscriptMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTranscript>>,
    TError,
    { transcriptId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  const mutationKey = ["deleteTranscript"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTranscript>>,
    { transcriptId: string }
  > = (props) => {
    const { transcriptId } = props ?? {};

    return deleteTranscript(transcriptId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTranscriptMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTranscript>>
>;

export type DeleteTranscriptMutationError = HTTPValidationError;

/**
 * @summary Delete Transcript
 */
export const useDeleteTranscript = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTranscript>>,
      TError,
      { transcriptId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTranscript>>,
  TError,
  { transcriptId: string },
  TContext
> => {
  return useMutation(getDeleteTranscriptMutationOptions(options), queryClient);
};

/**
 * Get the current user's scored calls.
 * @summary Get My Scores
 */
export type getMyScoresResponse200 = {
  data: MyScoresResponse;
  status: 200;
};

export type getMyScoresResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getMyScoresResponseSuccess = getMyScoresResponse200 & {
  headers: Headers;
};
export type getMyScoresResponseError = getMyScoresResponse422 & {
  headers: Headers;
};

export type getMyScoresResponse =
  | getMyScoresResponseSuccess
  | getMyScoresResponseError;

export const getGetMyScoresUrl = (params?: GetMyScoresParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/my-scores?${stringifiedParams}`
    : `/api/v1/analytics/my-scores`;
};

export const getMyScores = async (
  params?: GetMyScoresParams,
  options?: RequestInit,
): Promise<getMyScoresResponse> => {
  return customInstance<getMyScoresResponse>(getGetMyScoresUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMyScoresQueryKey = (params?: GetMyScoresParams) => {
  return [`/api/v1/analytics/my-scores`, ...(params ? [params] : [])] as const;
};

export const getGetMyScoresQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyScores>>,
  TError = HTTPValidationError,
>(
  params?: GetMyScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyScores>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyScoresQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyScores>>> = ({
    signal,
  }) => getMyScores(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyScores>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyScoresQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyScores>>
>;
export type GetMyScoresQueryError = HTTPValidationError;

export function useGetMyScores<
  TData = Awaited<ReturnType<typeof getMyScores>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetMyScoresParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyScores>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyScores>>,
          TError,
          Awaited<ReturnType<typeof getMyScores>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyScores<
  TData = Awaited<ReturnType<typeof getMyScores>>,
  TError = HTTPValidationError,
>(
  params?: GetMyScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyScores>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyScores>>,
          TError,
          Awaited<ReturnType<typeof getMyScores>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyScores<
  TData = Awaited<ReturnType<typeof getMyScores>>,
  TError = HTTPValidationError,
>(
  params?: GetMyScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyScores>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Scores
 */

export function useGetMyScores<
  TData = Awaited<ReturnType<typeof getMyScores>>,
  TError = HTTPValidationError,
>(
  params?: GetMyScoresParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyScores>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyScoresQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get the current user's score trends.
 * @summary Get My Trends
 */
export type getMyTrendsResponse200 = {
  data: MyTrendsResponse;
  status: 200;
};

export type getMyTrendsResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getMyTrendsResponseSuccess = getMyTrendsResponse200 & {
  headers: Headers;
};
export type getMyTrendsResponseError = getMyTrendsResponse422 & {
  headers: Headers;
};

export type getMyTrendsResponse =
  | getMyTrendsResponseSuccess
  | getMyTrendsResponseError;

export const getGetMyTrendsUrl = (params?: GetMyTrendsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/my-trends?${stringifiedParams}`
    : `/api/v1/analytics/my-trends`;
};

export const getMyTrends = async (
  params?: GetMyTrendsParams,
  options?: RequestInit,
): Promise<getMyTrendsResponse> => {
  return customInstance<getMyTrendsResponse>(getGetMyTrendsUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetMyTrendsQueryKey = (params?: GetMyTrendsParams) => {
  return [`/api/v1/analytics/my-trends`, ...(params ? [params] : [])] as const;
};

export const getGetMyTrendsQueryOptions = <
  TData = Awaited<ReturnType<typeof getMyTrends>>,
  TError = HTTPValidationError,
>(
  params?: GetMyTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyTrends>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetMyTrendsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyTrends>>> = ({
    signal,
  }) => getMyTrends(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getMyTrends>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetMyTrendsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getMyTrends>>
>;
export type GetMyTrendsQueryError = HTTPValidationError;

export function useGetMyTrends<
  TData = Awaited<ReturnType<typeof getMyTrends>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetMyTrendsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyTrends>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTrends>>,
          TError,
          Awaited<ReturnType<typeof getMyTrends>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyTrends<
  TData = Awaited<ReturnType<typeof getMyTrends>>,
  TError = HTTPValidationError,
>(
  params?: GetMyTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyTrends>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyTrends>>,
          TError,
          Awaited<ReturnType<typeof getMyTrends>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetMyTrends<
  TData = Awaited<ReturnType<typeof getMyTrends>>,
  TError = HTTPValidationError,
>(
  params?: GetMyTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyTrends>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get My Trends
 */

export function useGetMyTrends<
  TData = Awaited<ReturnType<typeof getMyTrends>>,
  TError = HTTPValidationError,
>(
  params?: GetMyTrendsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getMyTrends>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetMyTrendsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get org-level analytics summary. Requires sales_manager role or higher.
 * @summary Get Org Summary
 */
export type getOrgSummaryResponse200 = {
  data: OrgSummaryResponse;
  status: 200;
};

export type getOrgSummaryResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrgSummaryResponseSuccess = getOrgSummaryResponse200 & {
  headers: Headers;
};
export type getOrgSummaryResponseError = getOrgSummaryResponse422 & {
  headers: Headers;
};

export type getOrgSummaryResponse =
  | getOrgSummaryResponseSuccess
  | getOrgSummaryResponseError;

export const getGetOrgSummaryUrl = (params?: GetOrgSummaryParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/org/summary?${stringifiedParams}`
    : `/api/v1/analytics/org/summary`;
};

export const getOrgSummary = async (
  params?: GetOrgSummaryParams,
  options?: RequestInit,
): Promise<getOrgSummaryResponse> => {
  return customInstance<getOrgSummaryResponse>(getGetOrgSummaryUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOrgSummaryQueryKey = (params?: GetOrgSummaryParams) => {
  return [
    `/api/v1/analytics/org/summary`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetOrgSummaryQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgSummaryQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgSummary>>> = ({
    signal,
  }) => getOrgSummary(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgSummary>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgSummaryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgSummary>>
>;
export type GetOrgSummaryQueryError = HTTPValidationError;

export function useGetOrgSummary<
  TData = Awaited<ReturnType<typeof getOrgSummary>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetOrgSummaryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgSummary>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSummary>>,
          TError,
          Awaited<ReturnType<typeof getOrgSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgSummary<
  TData = Awaited<ReturnType<typeof getOrgSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgSummary>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgSummary>>,
          TError,
          Awaited<ReturnType<typeof getOrgSummary>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgSummary<
  TData = Awaited<ReturnType<typeof getOrgSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Org Summary
 */

export function useGetOrgSummary<
  TData = Awaited<ReturnType<typeof getOrgSummary>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgSummaryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgSummary>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrgSummaryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get per-user score breakdowns for the org. Requires sales_manager role or higher.
 * @summary Get Org Users
 */
export type getOrgUsersResponse200 = {
  data: OrgUsersResponse;
  status: 200;
};

export type getOrgUsersResponse422 = {
  data: HTTPValidationError;
  status: 422;
};

export type getOrgUsersResponseSuccess = getOrgUsersResponse200 & {
  headers: Headers;
};
export type getOrgUsersResponseError = getOrgUsersResponse422 & {
  headers: Headers;
};

export type getOrgUsersResponse =
  | getOrgUsersResponseSuccess
  | getOrgUsersResponseError;

export const getGetOrgUsersUrl = (params?: GetOrgUsersParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/analytics/org/users?${stringifiedParams}`
    : `/api/v1/analytics/org/users`;
};

export const getOrgUsers = async (
  params?: GetOrgUsersParams,
  options?: RequestInit,
): Promise<getOrgUsersResponse> => {
  return customInstance<getOrgUsersResponse>(getGetOrgUsersUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetOrgUsersQueryKey = (params?: GetOrgUsersParams) => {
  return [`/api/v1/analytics/org/users`, ...(params ? [params] : [])] as const;
};

export const getGetOrgUsersQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrgUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrgUsersQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrgUsers>>> = ({
    signal,
  }) => getOrgUsers(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrgUsers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrgUsersQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrgUsers>>
>;
export type GetOrgUsersQueryError = HTTPValidationError;

export function useGetOrgUsers<
  TData = Awaited<ReturnType<typeof getOrgUsers>>,
  TError = HTTPValidationError,
>(
  params: undefined | GetOrgUsersParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUsers>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgUsers>>,
          TError,
          Awaited<ReturnType<typeof getOrgUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgUsers<
  TData = Awaited<ReturnType<typeof getOrgUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUsers>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrgUsers>>,
          TError,
          Awaited<ReturnType<typeof getOrgUsers>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrgUsers<
  TData = Awaited<ReturnType<typeof getOrgUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Org Users
 */

export function useGetOrgUsers<
  TData = Awaited<ReturnType<typeof getOrgUsers>>,
  TError = HTTPValidationError,
>(
  params?: GetOrgUsersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrgUsers>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrgUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Get API version and build information.
 * @summary Get Api Info
 */
export type getApiInfoResponse200 = {
  data: InfoResponse;
  status: 200;
};

export type getApiInfoResponseSuccess = getApiInfoResponse200 & {
  headers: Headers;
};
export type getApiInfoResponse = getApiInfoResponseSuccess;

export const getGetApiInfoUrl = () => {
  return `/api/v1/info`;
};

export const getApiInfo = async (
  options?: RequestInit,
): Promise<getApiInfoResponse> => {
  return customInstance<getApiInfoResponse>(getGetApiInfoUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetApiInfoQueryKey = () => {
  return [`/api/v1/info`] as const;
};

export const getGetApiInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiInfo>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiInfo>>, TError, TData>
  >;
  request?: SecondParameter<typeof customInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiInfoQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiInfo>>> = ({
    signal,
  }) => getApiInfo({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiInfo>>
>;
export type GetApiInfoQueryError = unknown;

export function useGetApiInfo<
  TData = Awaited<ReturnType<typeof getApiInfo>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiInfo>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInfo>>,
          TError,
          Awaited<ReturnType<typeof getApiInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInfo<
  TData = Awaited<ReturnType<typeof getApiInfo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiInfo>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiInfo>>,
          TError,
          Awaited<ReturnType<typeof getApiInfo>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiInfo<
  TData = Awaited<ReturnType<typeof getApiInfo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Api Info
 */

export function useGetApiInfo<
  TData = Awaited<ReturnType<typeof getApiInfo>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiInfo>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiInfoQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}
